import React, {useEffect, useMemo, useState} from "react";
import {Alert, Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import Dropdown from "../../../primer/Dropdown";
import Input from "../../../common/Input";
import DateBox from "../../../primer/DateBox";
import {
  fetchAdvancedTypesSales,
  fetchBankAccounts,
  fetchCashRegisters,
  fetchPOS,
  fetchSalesGeneralSettings,
  putClient,
} from "../../../../_apis/api";
import EditableTable from "../../../primer/Editable-Table";
import QuickEdit from "../../../primer/QuickEdit";
import {useDispatch, useSelector} from "react-redux";
import {
  checkPermission,
  filterNaNValue,
  getCountryOptions,
  getCurrentUser,
  getDefaultOptionByValue,
  getDOYOptions,
  getGreekCurrencyFormat,
  getInstallationsTypes,
  getModeByInstallation,
  getNumberByInstallation,
  getOptionsByData,
  getPreNumberByInstallation,
  getSelectedInstallation,
  getSelectedPreNumbers,
  getVatCategoryOptions,
  isEmpty,
  removeDuplicateObjects,
} from "../../../../_helpers/commonFunctions";
import {setSaveSales} from "../../../../_reducers/activitySlice";
import {
    deleteObjectFromArrayOfObjects,
    findObjectFromArrayOfObjects, fixDocumentTaxesDisplay,
    getLabelByValue,
    getObjectFromArrayOfObjects
} from "../../../../_helpers/helperFunctions";
import {
  newSalesInitialValue,
  setCorrelatedDclData, setCorrelatedVisitData,
  setNewSaleClientCustomData,
  setNewSales,
  setNewSalesExtraData,
  setNewSalesNewProduct,
  setSalesDiscountObject,
  setCorrelatedSaleData
} from "../../../../_reducers/DataPanel/Sales/salesSlice";
import TextArea from "../../../common/TextArea";
import {preNumberGreek} from "../../../../_data/settings/advanced-types-search";
import {toast} from "react-toastify";
import getMyData, {getSpecialCategoryOptions, reverseDeliveryNotePurposes} from "../../../../_helpers/sharedmydata";
import axios from "axios";
import AdvancedCombobox from "../../../primer/AdvancedCombobox";
import NewClientModal from "../Clients/new-client-modal";
import {
  getDiscountExclusiveVat,
  getNetValue,
  getNetValueByTotalValue,
  getPriceExclusiveVat,
  getProductFee,
  getProductOtherTax,
  getProductStamp,
  getProductWithholdTax,
  getSalesTaxesData,
  getSalesTotals,
  getTaxes,
  getTotalValue,
  getUnitPrice,
  getVatPercent,
  getVatValue,
  parseNumber
} from "../../../../_helpers/product-sales-calculations";
import {vatCategoryData} from "../../../../_data/mydata/vatCategory";
import {loadingAddressOptions, salesLocationData} from "../../../../_data/sales/sales-payment-types";
import BetterCheckBox from "../../../common/BetterCheckBox";
import TipComponent from "../../../primer/TipComponent/TipComponent";
import moment from "moment";
import {Popover} from "antd";
import SelectAnathetousaModal from "../../../primer/POPUP-COMPONENTS/SelectAnathetousaModal";
import AccountingBox from "../../../primer/AccountingBox";
import {classicInternationalMeasurementUnits} from "../../../../_data/international_codes/international_codes";
import {isDeliveryNoteTypes} from "../../../../_data/mydata/isDeliveryNoteTypes";
import DateTimeBox from "../../../primer/DateTimeBox";
import HourPicker from "../../../primer/HourPicker";
import OtherCorrelatedEntitiesModal from "../../../primer/POPUP-COMPONENTS/otherCorrelatedEntitiesModal";
import {getOtherCorrelatedEntitiesTypes} from "../../../../_data/mydata/otherCorrelatedEntities";
import {setShowDclAfterSaleNew, setShowDclPageAfterSaleNew} from "../../../../_reducers/DataPanel/Dcl/dclSlice";
import Loader from "../../../primer/POPUP-COMPONENTS/Loader/PrimerLoader";
import "./salesnew.css";
import PackingsDeclarations from "../../../primer/POPUP-COMPONENTS/PackingsDeclarations/PackingsDeclarations";
import {useTranslation} from "../../../../hooks/useTranslation";

const apiURL2 = process.env.REACT_APP_API_URL2;

const SalesNew = ({lockPaymentType = false}) => {
  const {t} = useTranslation();
  let date = new Date();
  const currentTime = date.getHours() + ':' + String(date.getMinutes()).padStart(2, '0');
  const dispatch = useDispatch();
  const ACTIVITY = useSelector((state) => state.ACTIVITY);
  const PRODUCTS_DATA = useSelector((state) => state.PRODUCTS_DATA);
  const SALES = useSelector((state) => state.SALES);
  const company = useSelector((state) => state.COMPANY_DATA.company);
  const CLIENTS_DATA = useSelector((state) => state.CLIENTS_DATA);
  const SETTINGS = useSelector((state) => state.SETTINGS);
  const SALES_SETTINGS = useSelector((state) => state.SALES_SETTINGS);
  const CASH_DATA = useSelector((state) => state.CASH_DATA);
  const newSaleClientCustomData = useSelector((state) => state.SALES.newSaleClientCustomData);
  const clientVatCategory = newSaleClientCustomData.clientVatCategory;
  const clientVatReason = newSaleClientCustomData.clientVatReason;
  const clientCustomVat = newSaleClientCustomData.clientCustomVat;
  const countryData = getCountryOptions('all');
  const isProviderPosPayment = SALES.newSales?.documentType
      && SETTINGS.settings.advancedTypesSales.find((doc) => doc._id === SALES.newSales.documentType)
      && SALES.newSales.myDataPaymentId === "7"
      && SETTINGS.settings.advancedTypesSales.find((doc) => doc._id === SALES.newSales.documentType)?.mydataProvider === "active";
  const vatCreditTypes = ["5.1", "5.2", "11.4"]; // My Data Types that are allowed to issue VAT credit documents
  const correlatedVisitData = useSelector((state) => state.SALES.correlatedVisitData);
  const countryOptions = [{label: "Κενό", value: ""}, ...getCountryOptions("all")];
  const isDelivery = (SALES.newSales?.isDeliveryNote === true || ["9.1", "9.2", "9.3"].includes(SALES.newSales?.myDataType)) && isDeliveryNoteTypes.includes(SALES.newSales?.myDataType);

  const requestData = {
    company: company.id
  }
  const currentUser = getCurrentUser();
  const requestData2 = {
    company: company.id,
    year: String(company.year),
    isActive: "active",
    userId: currentUser.id
  }
  const productCodeColumns = [
    {
      label: t('SalesNew.productCodeTable.code'),
      name: "code",
    },
    {
      label: t('SalesNew.productCodeTable.alternativeCode'),
      name: "alternateCode",
    },
    {
      label: t('SalesNew.productCodeTable.productName'),
      name: "name",
    },
    {
      label: t('SalesNew.productCodeTable.alternativeName'),
      name: "alternateName",
    },
  ];
  const clientDropdownColumns = [
    {
      label: t('SalesNew.clientTable.code'),
      name: "systemCode",
    },
    {
      label: t('SalesNew.clientTable.name'),
      name: "name",
    },
    {
      label: t('SalesNew.clientTable.phone'),
      name: "phone",
    },
    {
      label: t('SalesNew.clientTable.email'),
      name: "email",
    },
    {
      label: t('SalesNew.clientTable.vatNumber'),
      name: "vatNumber",
    },
  ];
  const clientInstallationsDropdownColumns = [
    {
      label: t('SalesNew.installationTable.type'),
      name: "type",
    },
    {
      label: t('SalesNew.installationTable.address'),
      name: "address",
    }
  ];
  const corelatedDocumentColumns = [
    {
      label: t('SalesNew.corelatedTable.name'),
      name: "clientName",
    },
    {
      label: t('SalesNew.corelatedTable.clientVat'),
      name: "vat",
    },
    {
      label: t('SalesNew.corelatedTable.documentType'),
      name: "documentTypeName",
    },
    {
      label: t('SalesNew.corelatedTable.date'),
      name: "date",
    },
    {
      label: t('SalesNew.corelatedTable.preNumber'),
      name: "preNumber",
    },
    {
      label: t('SalesNew.corelatedTable.number'),
      name: "number",
    },
    {
      label: t('SalesNew.corelatedTable.totalAmount'),
      name: "totalAmount",
    },
  ];
  const dclListDropdownColumns = [
    {label: "Πινακίδα Οχήματος", name: "vehicleRegistrationNumber"},
    {label: "Ημερομηνία Εγγραφής", name: "creationDateTime"},
    {label: "Πελάτης", name: "clientName"},
    {label: "Κατηγορία Υπηρεσίας", name: "serviceCategory", options: [{value: "oneTime", label: "Άπαξ"}, {value: "recurring", label: "Επαναλαμβανόμενη"}, {value: "continuous", label: "Διαρκής"}]},
    {label: "Κατάσταση", name: "status", options: [{value: "open", label: "Εκκρεμείς"}, {value: "completed", label: "Ολοκληρωμένη"}, {value: "cancelled", label: "Ακυρωμένη"}]},
  ]
  const [refreshPage, setRefreshPage] = useState(0);
  const [showCorelatedDocument, setShowCorelatedDocument] = useState(false);
  const [isCorelatedDocumentMandatory, setIsCorelatedDocumentMandatory] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [showCategoryConfirmation, setshowCategoryConfirmation] = useState(false);
  const [tempCatValue, setTempCatValue] = useState({});
  const [readOnlySalesTime, setReadOnlySalesTime] = useState(false);
  const [readOnlySalesDate, setReadOnlySalesDate] = useState(false);
  const [allowOlderDate, setAllowOlderDate] = useState(false);
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [showProductTableSpinner, setProductTableSpinner] = useState('false');
  const [salesProductList, setSalesProductList] = useState(PRODUCTS_DATA.products.slice());
  const [clientsListData, setClientsListData] = useState(CLIENTS_DATA.clients.slice());
  const [clientInstallationListData, setClientInstallationListData] = useState(CLIENTS_DATA.installations.slice());
  const [corelatedDocumentsList, setCorelatedDocumentsList] = useState([]);
  const [correlatedDclList, setCorrelatedDclList] = useState([]);
  const [pRequestData, setPRequestData] = useState({});
  const permissions = localStorage.getItem("permissions");
  const permissionsData = JSON.parse(permissions);
  const [showDiscountModal, setShowDiscountModal] = useState(false);
  const [mainLoader, setMainLoader] = useState(false);

  const canHaveOtherCorrelations = !isEmpty(SALES.newSales.myDataType) && !["1.6", "2.4", "5.1"].includes(SALES.newSales.myDataType) && !isEmpty(SALES.newSales?.client);
  const [otherCorrelatedInvoicesDefaultData, setOtherCorrelatedInvoicesDefaultData] = useState([]);

  // Fetch Correlated Documents List
  const fetchCorrelatedDocumentsList = (keyword, setData, newMyDataType) => {
    let toRequestData = { company: company.id, myDataType: SALES.newSales?.myDataType };
    if (newMyDataType) toRequestData.myDataType = newMyDataType;
    if (keyword) toRequestData.keyword = keyword;
    axios.post(apiURL2 + `/sale/correlated-document-list`, toRequestData, {
      headers: { 'Content-Type': 'application/json'}
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        if (res.data.data && res.data.data.length > 0) {
          if (setData) {
            setData(res.data.data);
          } else {
            setCorelatedDocumentsList(res.data.data);
          }
        }
      }
    }).catch((err) => {
      console.log(err);
    })
  }

  const fetchCorrelatedDclList = (keyword, setData) => {
    if(!checkPermission("sales-dcl/new-write", permissionsData)) return;
    let reqData = {company: company.id, isFromSale: "true"};
    if (!isEmpty(keyword)) reqData.keyword = keyword;
    if(!isEmpty(SALES.newSales?.client)) reqData.client = SALES.newSales?.client;
    axios.post(process.env.REACT_APP_API_URL2 + `/dcl/dcl-list-correlated`, reqData, {
      headers: { "Content-Type": "application/json" }
    }).then((res) => {
      if (res.data && res.data.status === "200") {
        if (res.data.data) {
          let filteredData = res.data.data;
          if (setData) setData(filteredData);
        } else {
          if (setData) setData([]);
        }
      } else {
        if (setData) setData([]);
      }
    }).catch((e) => {
      console.log(e);
    })
  }

  const fetchOtherCorrelatedInvoicesData = (keyword, setData, forceClient, forceMyDataPaymentId) => {
    if (canHaveOtherCorrelations) {
      let requestData = {
        company: company.id,
        year: company.year,
        client: SALES.newSales.client,
        myDataPaymentId: SALES.newSales.myDataPaymentId,
        paymentAmount: SALES.newSales.paymentAmount,
        myDataType: SALES.newSales.myDataType,
      }
      if (!isEmpty(keyword)) requestData.keyword = keyword;
      if (!isEmpty(forceClient)) requestData.client = forceClient;
      if (!isEmpty(forceMyDataPaymentId)) requestData.myDataPaymentId = forceMyDataPaymentId;
      axios.post(apiURL2 + "/sale/other-correlated-invoices-list", requestData, {
        headers: { 'Content-Type': 'application/json'}
      }).then((res) => {
        if (res.data.status === "200") {
          if (setData) setData(res.data.data);
        } else {
          if (setData) setData([]);
        }
      }).catch((err) => {
        console.log(err);
      })
    }
  }

  useEffect(() => {
      dispatch(fetchAdvancedTypesSales(requestData));
      dispatch(fetchSalesGeneralSettings(requestData2));
      dispatch(fetchPOS(requestData2));
      dispatch(fetchBankAccounts(requestData2));
      dispatch(fetchCashRegisters(requestData2));
  }, []);

  useEffect(() => {
    // Update number after save and repeat
    if (SETTINGS.settings.advancedTypesSales && SALES.newSales.numberingMode !== 'manual') {
      const findDoc = SETTINGS.settings.advancedTypesSales.find((el) => el._id === SALES.newSales.documentType);
      if (findDoc) {
        const findDocNumbering = findDoc.documentNumbering.find((el) => el.installationMasterId === SALES.newSales.installation && String(SALES.newSales.preNumber) === String(el.preNumber))
        if (findDocNumbering) {
          if (Number(findDocNumbering.number) + 1 !== Number(SALES.newSales.number)) {
            dispatch(setNewSales({...SALES.newSales, number: findDocNumbering.number + 1}));
          }
        }
      }
    }
  }, [SETTINGS.settings.advancedTypesSales])

  useEffect(() => {
    // Load Product based on selected advanced type if my data rule applies
    if (SALES.newSales.documentType !== "") {
      loadClientsListData(SALES.newSales.documentType);
      loadProductListData(SALES.newSales.documentType);
      fetchCorrelatedDclList("", setCorrelatedDclList);
      let dtData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypesSales, SALES.newSales.documentType, '_id');
      if (dtData.length > 0) {
        let currentAdvancedType = dtData['0'];
        // Load Corelated document on page render
        loadCorelatedFieldSettings(currentAdvancedType);
        if (currentAdvancedType.enableMyDataRules && currentAdvancedType.enableMyDataRules === 'active') {
          let isEnabledMyDataRule = currentAdvancedType.enableMyDataRules === 'active';
          setReadOnlySalesTime(isEnabledMyDataRule);
          setReadOnlySalesDate(isEnabledMyDataRule);
          let isAllowOlderDate = currentAdvancedType.enableMyDataRules === 'active' && currentAdvancedType.allowOlderDate === 'active';
          setAllowOlderDate(isAllowOlderDate);
        }
      }
      if(SALES.newSales.installation !== undefined && SALES.newSales.installation !== ''){
        let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData['documentNumbering'], preNumberGreek, SALES.newSales.installation);
        setPreNumberGreekOptions(newPreNumbers);
      }
    }
  },[])
  //useEffect for loading sale template
  useEffect(() => {
    // Load Product based on selected advanced type if my data rule applies
    if (SALES.newSales.documentType !== "") {
      loadClientsListData(SALES.newSales.documentType);
      loadProductListData(SALES.newSales.documentType);
      let dtData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypesSales, SALES.newSales.documentType, '_id');
      if (dtData.length > 0) {
        let currentAdvancedType = dtData['0'];
        // Load Corelated document on page render
        loadCorelatedFieldSettings(currentAdvancedType);
        if (currentAdvancedType.enableMyDataRules && currentAdvancedType.enableMyDataRules === 'active') {
          let isEnabledMyDataRule = currentAdvancedType.enableMyDataRules === 'active';
          setReadOnlySalesTime(isEnabledMyDataRule);
          setReadOnlySalesDate(isEnabledMyDataRule);
          let isAllowOlderDate = currentAdvancedType.enableMyDataRules === 'active' && currentAdvancedType.allowOlderDate === 'active';
          setAllowOlderDate(isAllowOlderDate);
        }
      }
      if(SALES.newSales.installation !== undefined && SALES.newSales.installation !== '') {
        let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData['documentNumbering'], preNumberGreek, SALES.newSales.installation);
        setPreNumberGreekOptions(newPreNumbers);
        let newSalesData = {};
        let selectedInstallation = getObjectFromArrayOfObjects(selectedDocumentTypeData['documentNumbering'], SALES.newSales.installation, "installationMasterId");
        let selectedInstallationNumbering = selectedInstallation.filter(selected => selected.preNumber === SALES.newSales.preNumber);
        if (Object.keys(selectedInstallation).length > 0 && selectedInstallationNumbering.length > 0 && selectedInstallationNumbering[0].numberingMode !== "manual") {
          newSalesData.number = selectedInstallationNumbering[0].number + 1;
        } else {
          newSalesData.number = "";
        }
        dispatch(setNewSales({ ...SALES.newSales, ...newSalesData }));
      }
    }
  },[SALES.newSales.installation, SALES.newSales.preNumber])

  useEffect(() => {
    if (!isEmpty(SALES.newSales.client)) {
      fetchCorrelatedDclList("", setCorrelatedDclList);
    }
  }, [SALES.newSales.client]);

  const processCorrelatedDataSequence = async () => {
    setMainLoader(true);
    let currentSalesState = newSalesInitialValue;
    currentSalesState = await handleOnChange({value: correlatedVisitData.documentType, label: correlatedVisitData.documentTypeName}, 'dd', 'documentType', currentSalesState);
    currentSalesState = await handleOnChange({value: null, row: {_id: correlatedVisitData.client}}, 'acdd', 'client', currentSalesState);
    currentSalesState = await handleOnChange({value: correlatedVisitData.paymentType, label: correlatedVisitData.paymentTypeName}, 'dd', 'paymentType', currentSalesState);
    let prodIdx = 1;
    if (correlatedVisitData?.autoSaleProduct) { // Visits
      currentSalesState = await salesProductListActions.insert({key: ""}, {field: "productId", value: correlatedVisitData?.autoSaleProduct}, currentSalesState);
      if (correlatedVisitData?.peppol) currentSalesState = await salesProductListActions.update({unitPrice: 10}, prodIdx, null, null, currentSalesState);
      currentSalesState = await salesProductListActions.update({quantity: correlatedVisitData?.autoSaleProductQuantity || 1}, prodIdx, null, null, currentSalesState);
      prodIdx++;
    }
    if (correlatedVisitData?.peppol) {
      if (Object.keys(correlatedVisitData.peppol).length > 0) {
        currentSalesState.peppol = correlatedVisitData.peppol;

        if (correlatedVisitData?.discountAmount) {
          currentSalesState.discountAsLine = true;
          currentSalesState.discountAsLineText = "Άθροισμα ποσών παρακρατήσεως σύμφωνα με το άρθρ. 3 του Ν. 5102/2024 .";
        }
      }
    }
    if (correlatedVisitData?.referralArray?.length > 0) {
      for (const row of correlatedVisitData?.referralArray) {
        currentSalesState = await salesProductListActions.insert({key: ""}, {field: "productId", value: row.product}, currentSalesState);
        currentSalesState.products.forEach((prod) => {
          prod.quickEdit = true;
        })
        const prepUpdate = {};
        prepUpdate.unitPrice = +row.amount || 0;
        if (row.barcode === "MONTHLY_EOPYY_INVOICE") {
          prepUpdate.showAlternativeNameOnPrint = "true";
          prepUpdate.alternativeName = row.alternativeName;
        }
        currentSalesState = await salesProductListActions.update(prepUpdate, prodIdx, null, null, currentSalesState);
        currentSalesState = await salesProductListActions.update({quantity: +row.quantity || 1}, prodIdx, null, null, currentSalesState);
        if (row.discount) currentSalesState = await salesProductListActions.update({discount: +row.discount}, prodIdx, null, null, currentSalesState);
        prodIdx++;
      }
    }
    if (correlatedVisitData.notes) currentSalesState.notes += `\n${correlatedVisitData.notes}`;
    dispatch(setNewSales(currentSalesState));
    dispatch(setCorrelatedVisitData({}));
    setMainLoader(false);
  }

  const processCorrelatedSaleDataSequence = async () => {
    setMainLoader(true);
    const source = SALES.correlatedSaleData.sourceSale;
    const targetDocId = SALES.correlatedSaleData.targetDocumentType;
    let currentSalesState = newSalesInitialValue;

    currentSalesState = await handleOnChange(
        { value: targetDocId },
        'dd',
        'documentType',
        currentSalesState
    );

    if (source.client) {
      currentSalesState = await handleOnChange(
          { value: null, row: { _id: source.client } },
          'acdd',
          'client',
          currentSalesState
      );
    }

    if (source.paymentType) {
      currentSalesState = await handleOnChange(
          { value: source.paymentType },
          'dd',
          'paymentType',
          currentSalesState
      );
    }

    currentSalesState.salePurpose = source.salePurpose;
    currentSalesState.notes = source.notes;

    if (source.extraData) {
      currentSalesState.extraData = {
        ...currentSalesState.extraData,
        isRegime4200: source.extraData.isRegime4200 !== undefined ? String(source.extraData.isRegime4200) : "false",
        isTriangularTrade: source.extraData.isTriangularTrade !== undefined ? String(source.extraData.isTriangularTrade) : "false",
      };
    }

    if (SALES.correlatedSaleData?.sourceType && SALES.correlatedSaleData?.sourceType === 'quotation') {
      currentSalesState.sourceQuotation = source._id;
      currentSalesState.sourceQuotationName = getCorelatedDocumentName(source);
      currentSalesState.corelatedDocument = "";
      currentSalesState.corelatedDocumentName = "";
    } else {
      currentSalesState.corelatedDocument = source._id;
      currentSalesState.corelatedDocumentName = getCorelatedDocumentName(source);
      currentSalesState.sourceQuotation = "";
      currentSalesState.sourceQuotationName = "";
    }

    if (source.products && source.products.length > 0) {
      let prodIdx = 1;
      for (const product of source.products) {
        currentSalesState = await salesProductListActions.insert(
            { key: "" },
            { field: "productId", value: product._id },
            currentSalesState
        );

        const isPerDiscount = String(product.isPerDiscount) === "true" ? "true" : "false";
        const isDiscountAmount = String(product.isDiscountAmount) === "true" || isPerDiscount === "false" ? "true" : "false";
        currentSalesState = await salesProductListActions.update(
            {
              quantity: +product.quantity || 1,
              unitPrice: product.unitPrice,
              isPerDiscount: isPerDiscount,
              isDiscountAmount: isDiscountAmount,
              discount: +product.discount || 0
            },
            prodIdx,
            null,
            null,
            currentSalesState
        );

        prodIdx++;
      }
    }
    dispatch(setNewSales(currentSalesState));
    dispatch(setCorrelatedSaleData({}));
    setMainLoader(false);
  }

  useEffect(() => {
    if (!isEmpty(correlatedVisitData?.documentType) && !isEmpty(correlatedVisitData?.client)) {
      processCorrelatedDataSequence();
    }
  }, [correlatedVisitData])

  useEffect(() => {
    if(!isEmpty(SALES.correlatedDclData?._id)) {
      const processCorrelatedDataSequence = async () => {
        setMainLoader(true);
        let currentSalesState = newSalesInitialValue;
        currentSalesState = await handleOnChange({value: SALES.correlatedDclData?.documentType, label: SALES.correlatedDclData?.documentTypeName}, 'dd', 'documentType', currentSalesState);
        currentSalesState = await handleOnChange({value: null, row: {_id: SALES.correlatedDclData?.client}}, 'acdd', 'client', currentSalesState);
        currentSalesState = await handleOnChange({value: null, row: SALES.correlatedDclData}, 'acdd', 'correlatedDcl', currentSalesState);
        const foundSetting = SALES_SETTINGS?.salesGeneralSettings?.dclInstallationDefaultOptions?.find((ins) => ins?.installation === SALES.correlatedDclData?.installation);
        if (foundSetting && foundSetting?.product) {
          currentSalesState = await salesProductListActions.insert({key: ""}, {field: "productId", value: foundSetting.product}, currentSalesState);
          currentSalesState = await salesProductListActions.update({totalValue: (+SALES.correlatedDclData?.amount || 0).toFixed(2)}, 1, null, null, currentSalesState);
        }
        dispatch(setNewSales(currentSalesState));
        dispatch(setCorrelatedDclData({}));
        setMainLoader(false);
      };
      const timerId = setTimeout(processCorrelatedDataSequence, 0);
      return () => clearTimeout(timerId);
    }
  }, [SALES.correlatedDclData]);

  useEffect(() => {
    if (!isEmpty(SALES.correlatedSaleData?.targetDocumentType)) {
      processCorrelatedSaleDataSequence();
    }
  }, [SALES.correlatedSaleData]);

  // Options for Document Type Dropdown
  let pMDDSettings = SETTINGS.primerMyDataData;
  const documentTypesOptions = useMemo(() => getOptionsByData(SETTINGS.settings.advancedTypesSales, "_id", "name"), [SETTINGS.settings.advancedTypesSales]);
  const waysOfSendingGoodsOptions = useMemo(() => [{ value: "", label: t("Null") }, ...getOptionsByData(SALES_SETTINGS.salesGeneralSettings.sendingGoods, "_id", "name")], [SALES_SETTINGS.salesGeneralSettings.sendingGoods]);
  const carNumbersOptions = useMemo(() => [{ value: "", label: t("Null") }, ...getOptionsByData(SALES_SETTINGS.salesGeneralSettings.carNumbers, "_id", "number")], [SALES_SETTINGS.salesGeneralSettings.carNumbers]);

  let ptTypes = SALES_SETTINGS.salesGeneralSettings.paymentTypes;
  if ((SALES.newSales?.myDataType === "5.1" || SALES.newSales?.myDataType === "5.2" || SALES.newSales?.myDataType === "11.4") && isProviderPosPayment) {
    ptTypes = ptTypes.filter((el) => el.myDataPaymentId !== "7");
  }
  const paymentTypeOptions = getOptionsByData(ptTypes, "_id", "name");

  let otherTaxesOptions = useMemo(() => getOptionsByData(pMDDSettings?.otherTaxes !== undefined && pMDDSettings?.otherTaxes !== '' ? pMDDSettings.otherTaxes.filter(otherTax => otherTax.taxLevel === 1) : SETTINGS.otherHoldTaxes, 'code', 'name'), [pMDDSettings, SETTINGS.otherHoldTaxes]);
  let withHoldTaxesOptions = useMemo(() => getOptionsByData(pMDDSettings?.withHoldTaxes !== undefined && pMDDSettings?.withHoldTaxes !== '' ? pMDDSettings.withHoldTaxes.filter(withHoldTax => withHoldTax.taxLevel === 1) : SETTINGS.withHoldTaxes, 'code', 'name'), [pMDDSettings, SETTINGS.withHoldTaxes]);
  let stampOptions = useMemo(() => getOptionsByData(pMDDSettings?.stamp !== undefined && pMDDSettings?.stamp !== '' ? pMDDSettings.stamp.filter(stamp => stamp.taxLevel === 1) : SETTINGS.stamp, 'code', 'name'), [pMDDSettings, SETTINGS.stamp]);
  let feesOptions = useMemo(() => getOptionsByData(pMDDSettings?.fees !== undefined && pMDDSettings?.fees !== '' ? pMDDSettings.fees.filter(fee => fee.taxLevel === 1) : SETTINGS.fees, 'code', 'name'), [pMDDSettings, SETTINGS.fees]);
  otherTaxesOptions = [{ value: "", label: t("Null"), color: "#76AEB7" }, ...otherTaxesOptions]
  withHoldTaxesOptions = [{ value: "", label: t("Null"), color: "#76AEB7" }, ...withHoldTaxesOptions]
  stampOptions = [{ value: "", label: t("Null"), color: "#76AEB7" }, ...stampOptions]
  feesOptions = [{ value: "", label: t("Null"), color: "#76AEB7" }, ...feesOptions]
  const salesPurposeOptions = [{ value: "", label: t("Null")}, ...getMyData({type: 'salePurpose', settings: SETTINGS})];
  const measurementUnitOptions     = getMyData({type: 'mu', settings: SETTINGS});
  const [requiredPaymentType, setRequiredPaymentType] = useState(false);
  const [preNumberGreekOptions, setPreNumberGreekOptions] = useState([]);
  let selectedDocumentTypeData = [];
  let dtInstallationsOptions = [];
  let disabledFields = false;
  if (SALES.newSales.documentType === undefined || SALES.newSales.documentType === '') {
    disabledFields = true;
  } else {
    let dtData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypesSales, SALES.newSales.documentType, '_id');
    if (dtData.length > 0) {
      selectedDocumentTypeData = dtData['0'];
      dtInstallationsOptions = getOptionsByData(selectedDocumentTypeData['documentNumbering'], "installationMasterId", "installation");
      dtInstallationsOptions = removeDuplicateObjects(dtInstallationsOptions, 'value');
    }
  }

  const generatePackingsFromProducts = (allProducts) => {
    if (!allProducts || allProducts.length === 0) return [];

    const packingsMap = {};
    allProducts.forEach(prod => {
      const capacity = parseFloat(prod.packagingQuantity);
      const currentQty = parseFloat(prod.quantity);

      if (capacity > 0 && currentQty >= capacity) {
        const numPackages = Math.floor(currentQty / capacity);
        if (numPackages > 0) {
          const type = String(prod.packagingType || "1");
          const title = type === "6" ? (prod.otherPackagingTypeTitle || "Λοιπά") : "";
          const key = `${type}_${title}`;

          if (packingsMap[key]) {
            packingsMap[key].quantity += numPackages;
          } else {
            packingsMap[key] = {
              packagingType: type,
              otherPackagingTypeTitle: title,
              quantity: numPackages
            };
          }
        }
      }
    });
    return Object.values(packingsMap);
  };

  const clientProductsColumns = [
    {
      name: "Αρ.",
      field: "no",
      width: "40px",
      editable: false,
      inputType: {
        type: 'text',
      }
    },
    {
      name: t('SalesNew.productTable.code.code'),
      field: "code",
      width: "120px",
      editable: true,
      inputType: {
        config: {
          excludeColumns: [],
          columns: productCodeColumns,
          data: salesProductList,
          deleteEnable: false,
          searchTableEnable: false,
          showTableOptionOnSelect: true,
          placeholder: t('SalesNew.productTable.code.placeholder')
        },
        type: 'advanced-combobox',
      }
    },
    {
      name: t('SalesNew.productTable.name.name'),
      field: "name",
      width: "400px",
      editable: true,
      inputType: {
        config: {
          excludeColumns: [],
          columns: productCodeColumns,
          data: salesProductList,
          deleteEnable: false,
          searchTableEnable: false,
          showTableOptionOnSelect: true,
          placeholder: t('SalesNew.productTable.name.placeholder')
        },
        type: 'advanced-combobox',
      }
    },
    {
      name: t('SalesNew.productTable.quantity'),
      field: "quantity",
      width: "90px",
      editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
      inputType: {
        type: 'accounting',
        config: {
          maxLength: 10 // Given in the wireframe
        }
      }
    },
    {
      name: t('SalesNew.productTable.mu'),
      field: "muLabel",
      editable: false,
      width: "60px",
      inputType: {
        type: 'text',
      }
    },
    {
      name: t('SalesNew.productTable.unitPrice'),
      field: "unitPrice",
      editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
      width: "130px",
      inputType: {
        type: 'accounting',
        config: {
          suffix: "€",
          decimalLimit: 3,
          maxLength: 10,
        }
      }
    },
    {
      name: t('SalesNew.productTable.discount'),
      field: "discount",
      editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
      width: "80px",
      inputType: {
        type: 'accounting',
        config: {
          suffix: "€",
          maxLength: 10
        }
      }
    },
    {
      name: "%",
      field: "isPerDiscount",
      editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
      inputType: {
        type: 'radio',
        name: 'discountType',
        radioLogic: 'oneperrow',
        options: [{
          value: true,
          label: 'True'
        }, {
          value: false,
          label: 'False'
        }]
      }
    },
    {
      name: "€",
      field: "isDiscountAmount",
      editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
      inputType: {
        type: 'radio',
        radioLogic: 'oneperrow',
        name: 'discountType',
        options: [{
          value: true,
          label: 'True'
        }, {
          value: false,
          label: 'False'
        }]
      }
    },
    {
      name: t('SalesNew.productTable.vat'),
      field: "vatPercentage",
      inputType: {
        type: 'text',
      }
    },
    {
      name: t('SalesNew.productTable.netValue'),
      field: "netValue",
      editable: SALES_SETTINGS.salesGeneralSettings?.forbitChange !== "active",
      width: "150px",
      inputType: {
        type: 'accounting',
        config: {
          suffix: "€",
          maxLength: 10
        }
      }
    },
    {
      name: t('SalesNew.productTable.vatValue'),
      field: "vat",
      width: "90px",
      editableCallback: (rowData) => vatCreditTypes.includes(SALES.newSales.myDataType) && +rowData.netValue === 0,
      inputType: {
        type: 'accounting',
        config: {
          suffix: "€",
          maxLength: 10
        }
      }
    },
    {
      name: t('SalesNew.productTable.taxes'),
      field: "taxes",
      editable: false,
      width: "90px",
      inputType: {
        type: 'accounting',
        config: {
          suffix: "€",
          maxLength: 10
        }
      }
    },
    {
      name: t('SalesNew.productTable.totalValue'),
      field: "totalValue",
      editable: true,
      width: "150px",
      inputType: {
        type: 'accounting',
        config: {
          suffix: "€",
          maxLength: 10
        }
      }
    },
  ]

  const otherCorrelatedInvoicesTableColumns = [
    {
      name: "Παραστατικό",
      field: "docInfo",
      width: "60%",
      editable: true,
      inputType: {
        config: {
          excludeColumns: [],
          columns: [
            {label: "Ημ/νια", name: "date"},
            {label: "Παραστατικό", name: "docInfo"},
            {label: "ΜΑΡΚ", name: "docMark"},
            {label: "Τύπος", name: "docMyDataType"},
          ],
          data: otherCorrelatedInvoicesDefaultData,
          deleteEnable: false,
          searchTableEnable: false,
          showTableOptionOnSelect: true,
          placeholder: "Εισάγετε παραστατικό",
          onChangeSearchCell: (cellName, keyword, setData) => fetchOtherCorrelatedInvoicesData(keyword, setData),
        },
        type: 'advanced-combobox',
      }
    },
    {
      name: "MARK",
      field: "docMark",
      width: "20%",
      inputType: {
        type: 'text',
      }
    },
    {
      name: "Επιπλέον πληροφορίες",
      field: "docNotes",
      width: "20%",
      inputType: {
        type: 'text',
      }
    },
  ]

  useEffect(() => {
    if (canHaveOtherCorrelations) {
      fetchOtherCorrelatedInvoicesData(null, setOtherCorrelatedInvoicesDefaultData, SALES.newSales.client);
    }
  }, [])

  const handleConfirmCategory = async () => {
    // Populate Selected Category Data
    let newSalesData = {};
    let value = tempCatValue.new;
    newSalesData.documentType = value;
    newSalesData.documentTypeName = getLabelByValue(documentTypesOptions, value, 'value');
    newSalesData.corelatedDocument = "";
    newSalesData.corelatedDocumentName = "";
    newSalesData.correlatedDclObj = "";
    newSalesData.correlatedDclName = "";
    const selectedDocumentTypeData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypesSales, value, "_id");
    if (selectedDocumentTypeData.length > 0) {
      let selectedDTData = selectedDocumentTypeData['0'];
      newSalesData.myDataType = String(selectedDTData.myDataType);
      newSalesData.enablePeppol = selectedDTData?.enablePeppol === "active" ? "active" : "inactive";
      newSalesData.fuelInvoice = selectedDTData?.fuelInvoice === "active" ? "active" : "inactive";
      if (selectedDTData?.reverseDeliveryNotePurpose) newSalesData.reverseDeliveryNotePurpose = selectedDTData.reverseDeliveryNotePurpose;
      if ((newSalesData.myDataType !== "1.1" && newSalesData.myDataType !== "2.1"
          && newSalesData.myDataType !== "5.1" && newSalesData.myDataType !== "5.2") || selectedDTData?.mydataProvider !== "active") {
        newSalesData.enablePeppol = "inactive";
      }
      newSalesData.isDeliveryNote = selectedDTData?.isDeliveryNote === "active";
      if (selectedDTData?.nonObligatedRecipient) newSalesData.nonObligatedRecipient = selectedDTData?.nonObligatedRecipient === "active";
      if (selectedDTData?.withoutDigitalTransportTracking) newSalesData.withoutDigitalTransportTracking = selectedDTData?.withoutDigitalTransportTracking === "active";
      if (selectedDTData?.vatPaymentSuspension === "active") {
          newSalesData.vatPaymentSuspension = true;
      } else {
          newSalesData.vatPaymentSuspension = undefined;
      }
      setActiveTab(0);
      newSalesData.paymentType = "";
      newSalesData.paymentTypeName = "";
      newSalesData.myDataPaymentId = "";
      newSalesData.bankAccount = "";
      newSalesData.bankAccountName = "";
      loadCorelatedFieldSettings(selectedDTData);
      let selectedInstallation = getSelectedInstallation(selectedDTData['documentNumbering']);
      // This applies only if selected check box is tick in the table.
      if (Object.keys(selectedInstallation).length > 0) {
        newSalesData.installation = selectedInstallation.installationMasterId;
        newSalesData.preNumber = selectedInstallation.preNumber;
        newSalesData.installationMode = selectedInstallation.numberingMode;
        newSalesData.numberingMode = selectedInstallation.numberingMode;
        newSalesData.number = selectedInstallation.number + 1;
      } else if(dtInstallationsOptions.length === 1){
        newSalesData.installation = dtInstallationsOptions[0].value;
        newSalesData.preNumber = "";
        newSalesData.number = "";
        newSalesData.installationMode = "";
        newSalesData.numberingMode = "";
      } else {
        newSalesData.installation = "";
        newSalesData.preNumber = "";
        newSalesData.number = "";
        newSalesData.installationMode = "";
        newSalesData.numberingMode = "";
      }
      // This will pre number given in document number table
      let newPreNumbers = getSelectedPreNumbers(selectedDTData['documentNumbering'], preNumberGreek, selectedInstallation.installationMasterId);
      setPreNumberGreekOptions(newPreNumbers);
      // Preposed Sales Purpose from the advanced types page
      newSalesData.salePurpose = selectedDTData.proposedSalePurpose;
      newSalesData.specialInvoiceCategory = selectedDTData?.specialInvoiceCategory ? selectedDTData.specialInvoiceCategory : "";
      loadProductListData(value);
      loadClientsListData(value);
      // Load Product based on selected advanced type if my data rule applies
      if (selectedDTData.enableMyDataRules && selectedDTData.enableMyDataRules === 'active') {
        setRequiredPaymentType(true);
        let isEnabledMyDataRule = selectedDTData.enableMyDataRules === 'active';
        setReadOnlySalesTime(isEnabledMyDataRule);
        setReadOnlySalesDate(isEnabledMyDataRule);
        let isAllowOlderDate = selectedDTData.enableMyDataRules === 'active' && selectedDTData.allowOlderDate === 'active';
        setAllowOlderDate(isAllowOlderDate);
      }
      // Clear Product List on change
      newSalesData.products = [];
      //Clear Client
      newSalesData.client = "";
      newSalesData.clientName = "";
      newSalesData.clientCode = "";
      newSalesData.address = "";
      newSalesData.vat = "";
      newSalesData.doy = "";
      newSalesData.city = "";
      newSalesData.amka = "";
      newSalesData.clientCategoryName = "";
      newSalesData.clientCategory = "";
      newSalesData.country = "";
      newSalesData.pc = "";
      newSalesData.email = "";
      newSalesData.phone = "";
      newSalesData.activity = "";
      newSalesData.vatCategory = "";
      setClientInstallationListData(CLIENTS_DATA.installations.slice());
      newSalesData.clientInstallationType = "";
      newSalesData.clientInstallationId = "";
      // Set Client Vat Category used for product vat calculation
      dispatch(setNewSaleClientCustomData({
        clientVatCategory: "Normal VAT",
        clientVatReason: "",
        clientCustomVat: 0,
      }))
      // This applies on Date and Time fields
      let isEnabledMyDataRule = selectedDTData.enableMyDataRules === 'active';
      setReadOnlySalesTime(isEnabledMyDataRule);
      setReadOnlySalesDate(isEnabledMyDataRule);
      let isAllowOlderDate = selectedDTData.enableMyDataRules === 'active' && selectedDTData.allowOlderDate === 'active';
      setAllowOlderDate(isAllowOlderDate);
    }
    dispatch(setNewSales({ ...SALES.newSales, ...newSalesData }));
    setshowCategoryConfirmation(false);
  }

  const loadClientsListDataOnChange = (value, setData) => {
    let data = {
      id: SALES.newSales.documentType,
      name: value,
      company : company.id
    }
    axios.get(process.env.REACT_APP_API_URL2 + `/client/client-list-by-advanced-type-id/${data.id}`,{params :data})
        .then(res => {
          if (res.data && res.data.status === '200') {
            if (res.data.data) {
              // Remove none empty client name data
              let filteredData = deleteObjectFromArrayOfObjects(res.data.data, '', 'name');
              setData(filteredData);
            } else {
              setData([]);
            }
          } else {
            setData([]);
          }
        }).catch((err) => {
          console.log(err);
        })
  }
  const onChangeSearch = (keyword,setData) => {
    if(keyword.length >= 2) {
      loadClientsListDataOnChange(keyword,setData)
    }
  }

  const loadClientsListData = (value) => {
    const data = {
      id: value,
      company : company.id,
      name:''
    }
    axios.get(process.env.REACT_APP_API_URL2 + `/client/client-list-by-advanced-type-id/${value}`,{params :data})
        .then(res => {
          if (res.data && res.data.status === '200') {
            if (res.data.data) {
              // Remove none empty client name data
              let filteredData = deleteObjectFromArrayOfObjects(res.data.data, '', 'name');
              setClientsListData([...filteredData]);
            } else {
              setClientsListData([]);
            }
          } else {
            setClientsListData([]);
          }
        }).catch((err) => {
          console.log(err);
        })
  }

  const loadProductListData = (value) => {
    const data = {
      id: value,
      name: '',
      company : company.id,
      hide0stockProducts: SALES_SETTINGS?.salesGeneralSettings?.hide0stockProducts
    }
    setPRequestData({...data});
    axios.get(process.env.REACT_APP_API_URL2 + `/sale/product-list-by-advanced-type-id/${data.id}`,{params :data})
        .then(res => {
          if (res.data && res.data.status === '200') {
            if (res.data.data) {
              setSalesProductList(res.data.data);
            } else {
              setSalesProductList([]);
            }
          } else {
            setSalesProductList([]);
          }
        }).catch((err) => {
          console.log(err);
        })
  }

  const loadCorelatedFieldSettings = (selectedDTData) => {
    if (selectedDTData.myDataType && selectedDTData.myDataType !== '') {
      // Show field only if "Document type" supports "MyData Document Type"
      // Is settings-Document Types-Advanced types that is 1.6, 2.4, 5.1
      if (
          String(selectedDTData.myDataType) === '1.6' ||
          String(selectedDTData.myDataType) === '2.4' ||
          String(selectedDTData.myDataType) === '5.1'
      ) {
        fetchCorrelatedDocumentsList(null, null, String(selectedDTData.myDataType));
        setShowCorelatedDocument(true);
      } else {
        setShowCorelatedDocument(false);
      }

      // If Advanced type is 5.1, field is mandatory, if not, field is not mandatory.
      if (String(selectedDTData.myDataType) === '5.1') {
        setIsCorelatedDocumentMandatory(true);
      } else {
        setIsCorelatedDocumentMandatory(false);
      }
    }
  }

  const getCorelatedDocumentName = (selectedCDoc) => {
    let dName = `${selectedCDoc.documentTypeName}`;
    if (selectedCDoc.preNumber && selectedCDoc.preNumber !== 'noprefix') {
      dName += ` | ${selectedCDoc.preNumber}`
    }
    if (selectedCDoc.number) {
      dName += ` | ${selectedCDoc.number}`;
    }
    return dName;
  }

  const handleOnChange = async (e, type = "default", ddname = '', currentSalesState = null) => {
    if (!ACTIVITY.saveSales) dispatch(setSaveSales(true));

    let name;
    let value = '';
    if (type === 'dd' || type === 'ac') {
      value = e.value;
      name = ddname;
    } else if (type === 'dp') {
      value = e;
      name = ddname;
    } else if (type === 'acdd') {
      e = e.row;
      value = e._id;
      name = ddname;
    } else if (type === 'tp') {
      value = e;
      name = ddname;
    } else if (type === "checkbox") {
      value = e.target.checked;
      name = ddname;
    } else if (type === "bettercheckbox") {
      value = e.target.checked ? "active" : "inactive";
      name = ddname;
    } else {
      value = e.target.value;
      name = e.target.name;
    }

    let salesData = Object.assign({}, currentSalesState ? currentSalesState : SALES.newSales);
    let newSalesData = {};
    if (name === "nonObligatedRecipient" && salesData.withoutDigitalTransportTracking) newSalesData.withoutDigitalTransportTracking = false;
    if (name === "withoutDigitalTransportTracking" && salesData.nonObligatedRecipient) newSalesData.nonObligatedRecipient = false;

    if (name === "time") {
      if (value !== currentTime && value !== null) {
        newSalesData.customTime = "true";
      }
    }
    if (name === "date") {
      if (value !== date && value !== null) {
        newSalesData.customTime = "true";
      }
    }
    if (name === 'documentType' && salesData.documentType !== value) {
      if (!isEmpty(SALES_SETTINGS?.salesGeneralSettings?.proposedSaleNotes)) {
        newSalesData["notes"] = SALES_SETTINGS.salesGeneralSettings.proposedSaleNotes;
      }
      if (salesData.documentType !== "") {
        newSalesData.otherCorrelatedInvoices = [];
        newSalesData.corelatedDocument = "";
        newSalesData.corelatedDocumentName = "";
        newSalesData.correlatedDclObj = "";
        newSalesData.correlatedDclName = "";
        // Show confirmation before category change.
        setshowCategoryConfirmation(true);
        setTempCatValue({ e: e, new: value, old: salesData.documentType });
      } else {
        // Populate Selected Category Data
        newSalesData[name] = value;
        let dtData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypesSales, value, '_id');
        if (dtData.length > 0) {
          dtInstallationsOptions = getOptionsByData(dtData['0']['documentNumbering'], "installationMasterId", "installation");
          dtInstallationsOptions = removeDuplicateObjects(dtInstallationsOptions, 'value');
        }
        newSalesData.documentTypeName = getLabelByValue(documentTypesOptions, value, 'value');
        const selectedDocumentTypeData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypesSales, value, "_id");
        if (selectedDocumentTypeData.length > 0) {
          let selectedDTData = selectedDocumentTypeData['0'];
          newSalesData.myDataType = selectedDTData?.myDataType ? String(selectedDTData.myDataType) : "";
          newSalesData.enablePeppol = selectedDTData?.enablePeppol === "active" ? "active" : "inactive";
          newSalesData.fuelInvoice = selectedDTData?.fuelInvoice === "active" ? "active" : "inactive";
          if (selectedDTData?.reverseDeliveryNotePurpose) newSalesData.reverseDeliveryNotePurpose = selectedDTData.reverseDeliveryNotePurpose

          if ((newSalesData.myDataType !== "1.1" && newSalesData.myDataType !== "2.1"
              && newSalesData.myDataType !== "5.1" && newSalesData.myDataType !== "5.2") || selectedDTData?.mydataProvider !== "active") {
            newSalesData.enablePeppol = "inactive";
          }
          newSalesData.isDeliveryNote = selectedDTData?.isDeliveryNote === "active";
          if (selectedDTData?.nonObligatedRecipient) newSalesData.nonObligatedRecipient = selectedDTData?.nonObligatedRecipient === "active";
          if (selectedDTData?.withoutDigitalTransportTracking) newSalesData.withoutDigitalTransportTracking = selectedDTData?.withoutDigitalTransportTracking === "active";
          if (selectedDTData?.vatPaymentSuspension === "active") {
              newSalesData.vatPaymentSuspension = true;
          } else {
              newSalesData.vatPaymentSuspension = undefined;
          }
          setActiveTab(0);
          loadCorelatedFieldSettings(selectedDTData);
          let selectedInstallation = getSelectedInstallation(selectedDTData['documentNumbering']);
          if (Object.keys(selectedInstallation).length > 0) {
            newSalesData.installation = selectedInstallation.installationMasterId;
            newSalesData.preNumber = selectedInstallation.preNumber;
            newSalesData.installationMode = selectedInstallation.numberingMode;
            newSalesData.numberingMode = selectedInstallation.numberingMode;
            if(newSalesData.numberingMode !== "manual") {
              newSalesData.number = selectedInstallation.number + 1;
            }
          } else if(dtInstallationsOptions.length === 1){
            newSalesData.installation = dtInstallationsOptions[0].value;
            newSalesData.preNumber = "";
            newSalesData.number = "";
            newSalesData.installationMode = "";
            newSalesData.numberingMode = "";
          } else {
            newSalesData.installation = "";
            newSalesData.preNumber = "";
            newSalesData.number = "";
            newSalesData.installationMode = "";
            newSalesData.numberingMode = "";
          }

          // This will pre number given in document number table
          let newPreNumbers = getSelectedPreNumbers(selectedDTData['documentNumbering'], preNumberGreek, newSalesData.installation);
          setPreNumberGreekOptions(newPreNumbers);
          // Preposed Sales Purpose from the advanced types page
          newSalesData.salePurpose = selectedDTData.proposedSalePurpose;
          newSalesData.specialInvoiceCategory = selectedDTData?.specialInvoiceCategory ? selectedDTData.specialInvoiceCategory : "";

          // Load Product based on selected advanced type if my data rule applies
          if (selectedDTData.enableMyDataRules && selectedDTData.enableMyDataRules === 'active') {
            loadProductListData(value);
            loadClientsListData(value);
            setRequiredPaymentType(true);
            let isEnabledMyDataRule = selectedDTData.enableMyDataRules === 'active';
            setReadOnlySalesTime(isEnabledMyDataRule);
            setReadOnlySalesDate(isEnabledMyDataRule);
            let isAllowOlderDate = selectedDTData.enableMyDataRules === 'active' && selectedDTData.allowOlderDate === 'active';
            setAllowOlderDate(isAllowOlderDate);
          }
        }
      }
    } else {
      newSalesData[name] = value;
    }

    if (name === 'client') {
      if (canHaveOtherCorrelations) {
        fetchOtherCorrelatedInvoicesData(null, setOtherCorrelatedInvoicesDefaultData, value);
      }
      newSalesData.otherCorrelatedInvoices = [];
      // populating client values on the sales form
      // Same code is used with quick edit client to repopulate the data after change. Starts from line number 933.
      let selectedClient = getObjectFromArrayOfObjects(clientsListData, value, '_id');
      // Get Client Data from the API.
      await axios.get(apiURL2 + `/client/get-client-id-by/${value}`)
          .then((res) => {
            if (res.data && res.data.status === "200") {
              selectedClient['0'] = res.data.data;
            }
          }).catch((err) => {
            console.log(err);
          })
      if (selectedClient.length > 0) {
        let sClient = selectedClient['0'];
        newSalesData.clientName = sClient.name;
        newSalesData.clientCode = !isEmpty(sClient.manualCode) ? sClient.manualCode : sClient.systemCode; // It is the client code
        newSalesData.address = sClient.address;
        newSalesData.vat = String(sClient.vatNumber).trim();
        newSalesData.doy = getLabelByValue(getDOYOptions(), Number(sClient.DOY), 'value');
        newSalesData.city = sClient.city;
        newSalesData.amka = sClient?.amka;
        newSalesData.clientCategoryName = sClient?.categoryName;
        newSalesData.clientCategory = sClient?.category;
        newSalesData.country = sClient.country;
        newSalesData.pc = sClient.postalCode;
        newSalesData.email = sClient.email;
        newSalesData.phone = sClient.phone;
        newSalesData.activity = sClient.activity;
        newSalesData.vatCategory = sClient.vatCategory;
        sClient.installations.map(installation => {
          installation.type = getLabelByValue(getInstallationsTypes(), installation.type, 'value');
          return installation;
        })
        setClientInstallationListData(sClient.installations);
        newSalesData.clientInstallationType = sClient.installations[0]?.type;
        newSalesData.clientInstallationId = sClient.installations[0]?.no;
        // Set Client Vat Category used for product vat calculation
        dispatch(setNewSaleClientCustomData({
          clientVatCategory: sClient?.vatCategory ? sClient.vatCategory : "Normal VAT",
          clientVatReason: sClient?.vatReason ? sClient.vatReason : "",
          clientCustomVat: !isEmpty(sClient?.customVat) ? sClient.customVat : 0,
        }))
      }
      //reset correlated DCl
      if(!isEmpty(salesData.correlatedDclObj) && (newSalesData?.client !== salesData?.client)) {
        newSalesData.correlatedDclObj = "";
        newSalesData.correlatedDclName = "";
      }
      if (!isEmpty(salesData.sourceQuotation)) {
        newSalesData.sourceQuotation = "";
        newSalesData.sourceQuotationName = "";
      }
    }

    if(name === 'clientInstallation'){
      let selectedClientInstallation = "";
      clientInstallationListData.map(installation => {
        if(value === installation._id){
          selectedClientInstallation = installation;
        }
        return installation;
      })
      if(selectedClientInstallation !== ""){
        newSalesData.clientInstallationType = selectedClientInstallation.type;
        newSalesData.clientInstallationId = selectedClientInstallation.no;
        newSalesData.address = selectedClientInstallation.address;
        newSalesData.doy = getLabelByValue(getDOYOptions(), Number(selectedClientInstallation.DOY), 'value');
        newSalesData.city = selectedClientInstallation.city;
        newSalesData.pc = selectedClientInstallation.postalCode;
      }
    }

    if (name === 'paymentType') {
      newSalesData.otherCorrelatedInvoices = [];
      newSalesData.paymentTypeName = getLabelByValue(paymentTypeOptions, value, 'value');

      // This will update the pre-selected POS / Bank
      let paymentTypesData = getObjectFromArrayOfObjects(SALES_SETTINGS.salesGeneralSettings.paymentTypes, value, '_id');
      if (paymentTypesData && paymentTypesData.length > 0) {
        let selectedPaymentType = paymentTypesData['0'];
        newSalesData.myDataPaymentId = selectedPaymentType?.myDataPaymentId;
        if (canHaveOtherCorrelations) {
          fetchOtherCorrelatedInvoicesData(null, setOtherCorrelatedInvoicesDefaultData, null, selectedPaymentType?.myDataPaymentId);
        }
        if (selectedPaymentType?.type === "pos") {
          newSalesData.bankAccount = selectedPaymentType.options?.preSelectedPosBankAccount;
        }

        if (selectedPaymentType?.type === "bank-account" || selectedPaymentType?.type === "bank-account-outside" || selectedPaymentType?.type === "web-banking") {
          newSalesData.bankAccount = selectedPaymentType.options?.preSelectedPosBankAccount;
        }

        if (selectedPaymentType?.type === "cash") {
          newSalesData.bankAccount = "";
        }

        if (SALES.newSales?.enablePeppol === "active" && !isEmpty(newSalesData.paymentTypeName) && isEmpty(SALES.newSales?.peppol?.paymentMethodInfo)) {
          newSalesData.peppol = {};
          if (SALES.newSales.peppol) newSalesData.peppol = {...SALES.newSales.peppol}
          newSalesData.peppol.paymentMethodInfo = newSalesData.paymentTypeName;
        }
      }
    }

    // Get Corelated Document Name
    if (name === 'corelatedDocument') {
      let doc;
      let selectedCDoc = findObjectFromArrayOfObjects(corelatedDocumentsList, value, '_id');
      if (selectedCDoc) {
        doc = selectedCDoc;
      } else {
        doc = e;
      }
      newSalesData.corelatedDocumentName = getCorelatedDocumentName(doc);
      newSalesData.otherCorrelatedInvoices = [];
      let copyKeys = ["client", "clientName", "clientCode", "category", "address", "vat", "doy", "city", "amka", "country", "categoryName",
        "pc", "email", "phone", "activity", "vatCategory", "clientType", "clientInstallationType", "clientInstallationId", "installation"]
      await axios.get(apiURL2 + `/client/get-client-id-by/${doc.client}`)
        .then((res) => {
          if (res.data && res.data.status === "200") {
            dispatch(setNewSaleClientCustomData({
              clientVatCategory: res.data.data?.vatCategory ? res.data.data?.vatCategory : "Normal VAT",
              clientVatReason: res.data.data?.vatReason ? res.data.data?.vatReason : "",
              clientCustomVat: !isEmpty(res.data.data?.customVat?.customVat) ? res.data.data?.customVat : 0,
            }))
          }
        }).catch((err) => {
            console.log(err);
          })
      for (let key of copyKeys) {
        if(key === "categoryName") {
          newSalesData["clientCategoryName"] = doc[key];
        } else if(key === "category") {
          newSalesData["clientCategory"] = doc[key];
        } else {
          newSalesData[key] = doc[key];
        }
      }

      if (doc.extraData) {
        newSalesData.extraData = {
          ...salesData.extraData,
          isRegime4200: doc.extraData.isRegime4200 !== undefined ? String(doc.extraData.isRegime4200) : "false",
          isTriangularTrade: doc.extraData.isTriangularTrade !== undefined ? String(doc.extraData.isTriangularTrade) : "false",
        };
      }

      if (doc.enablePeppol === "active" && doc?.peppol && SALES.newSales.myDataType === "5.1") {
        newSalesData.enablePeppol = "active";
        newSalesData.peppol = {};
        newSalesData.peppol.projectReference = "";
        newSalesData.peppol.partyIdentification = doc.peppol.partyIdentification;
        newSalesData.peppol.contractDocumentReference = doc.peppol.contractDocumentReference;
        newSalesData.peppol.dueDate = moment(SALES.newSales.date).format("YYYY-MM-DD");
        newSalesData.peppol.invoiceDocumentReference
            = `${company.vatNumber}|${moment(doc.date).utc().format("DD/MM/YYYY")}|${newSalesData.installation}|${doc.myDataType}|${doc.preNumber === "noprefix" ? "0" : doc.preNumber}|${doc.number}`;
        //newSalesData.peppol.documentMeasurementUnit = doc.peppol.documentMeasurementUnit;
      }
    }

    if(name === "correlatedDcl") {
      newSalesData.correlatedDclObj = e._id;
      newSalesData.correlatedDclName = `${e.vehicleRegistrationNumber} - ${e.vehicleFactory} - ${moment(e?.creationDateTime).format("DD/MM/YYYY HH:mm")} (${e?.dclId})`;
    }

    // Bank Account name
    if (name === 'bankAccount') {
      newSalesData.bankAccountName = getLabelByValue(bankOptions, value, 'value')
    }
    // Update Installtion Field Values on Change
    if (name === 'installation') {
      newSalesData.installationName = getLabelByValue(dtInstallationsOptions, value, 'value');
      newSalesData.preNumber = getPreNumberByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId');
      newSalesData.installationMode = getModeByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId');
      newSalesData.numberingMode = getModeByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId');
      if(newSalesData.numberingMode !== "manual") {
        newSalesData.number = getNumberByInstallation(selectedDocumentTypeData['documentNumbering'], value, 'installationMasterId') + 1;
      }
      // This will pre number given in document number table
      let newPreNumbers = getSelectedPreNumbers(selectedDocumentTypeData['documentNumbering'], preNumberGreek, value);
      setPreNumberGreekOptions(newPreNumbers);
    }
    if(name === "date" && (readOnlySalesDate === false || (readOnlySalesDate === true  && allowOlderDate === true))){
      if(readOnlySalesDate === true  && allowOlderDate === true){
        let allowedDateHours = checkPermission("custom-logistirio", permissionsData) === false ? pMDDSettings.otherData.filter(otherData => otherData.name === "allowOlderDate")[0].value : "999999";
        let allowedDate = new Date();
        allowedDate.setHours(allowedDate.getHours() - Number(allowedDateHours));
        if(allowedDate > new Date(value)){
          toast.error("You are not allowed to issue invoices before " + allowedDate.toString());
          newSalesData['date'] = new Date();
        } else {
          newSalesData['date'] = new Date(value);
          newSalesData['transmissionFailure'] = "1";
        }
      } else {
        newSalesData['date'] = new Date(value);
      }
    }
    if (name === "salePurpose") {
      newSalesData['salePurposeName'] = "";
    }
    // It will update the last available number from the API.
    if ((name === 'documentType' || name === 'preNumber' || name === 'installation') &&
        (
            (salesData.documentType !== '' || newSalesData.documentType !== '') &&
            (salesData.preNumber !== '' || newSalesData.preNumber !== '') &&
            (salesData.installation !== '' || newSalesData.installation !== '')
        )) {
      let checkAtParams = {};
      checkAtParams.company = company.id;
      checkAtParams.id = !newSalesData.documentType ? salesData.documentType : newSalesData.documentType;
      checkAtParams.preNumber = !newSalesData.preNumber ? salesData.preNumber : newSalesData.preNumber;
      checkAtParams.installation = !newSalesData.installation ? String(salesData?.installation) : String(newSalesData?.installation);

      if (checkAtParams.id && checkAtParams.preNumber && checkAtParams.installation && allowOlderDate === false) {
        let returnData = null;
        await axios.post(apiURL2 + `/settings/add-setting-advance-type-check-sale`, checkAtParams, { headers: { 'Content-Type': 'application/json' } })
            .then(res => {
              if (res.data && res.data.status === '200') {
                if (res.data.number !== undefined && allowOlderDate === false) {
                  newSalesData.number = parseInt(res.data.number) + 1;
                }
              }
              if(currentSalesState) {
                returnData = { ...salesData, ...newSalesData };
              } else {
                dispatch(setNewSales({ ...salesData, ...newSalesData }));
              }
            }).catch((err) => {
              console.log(err);
            })
        if(returnData) return returnData;
      } else {
        if(currentSalesState) {
          return { ...salesData, ...newSalesData };
        } else {
          dispatch(setNewSales({ ...salesData, ...newSalesData }));
        }
      }
    } else {
      if(currentSalesState) {
        return { ...salesData, ...newSalesData };
      } else {
        dispatch(setNewSales({ ...salesData, ...newSalesData }));
      }
    }
  }

  const handleOnChangeExtraData = (e, type = "default", ddname = '') => {
    // Set if editing the form
    if (!ACTIVITY.saveSales) {
      dispatch(setSaveSales(true));
    }
    let name;
    let value;

    if (type === 'dd' || type === 'ac') {
      value = e.value;
      name = ddname;
    } else if (type === 'dp' || type === "dtb") {
      value = e;
      name = ddname;
    } else if (type === 'tp') {
      value = e;
      name = ddname;
    } else if (type === "acb") {
      value = e.target.value;
      name = ddname;
    } else if (type === "cb") {
      value = String(e.target.checked)
      name = ddname;
    } else {
      value = e.target.value;
      name = e.target.name;
    }

    let extraData = {...SALES.newSales.extraData};
    extraData[name] = String(value);

    if (name === 'wayOfSendingGoods') {
      extraData.wayOfSendingGoodsName = getLabelByValue(waysOfSendingGoodsOptions, value, 'value');
    } else if (name === 'carNumber') {
      extraData.carNumberName = getLabelByValue(carNumbersOptions, value, 'value');
    } else if (name === 'otherTax') {
      extraData.otherTax = value;
      if (!isEmpty(value)
          && SETTINGS.primerMyDataData?.otherTaxes?.find((el) => el.code === value)?.taxPer === "false"
          && !isNaN(SETTINGS.primerMyDataData?.otherTaxes?.find((el) => el.code === value)?.tax)
          && !isEmpty(SETTINGS.primerMyDataData?.otherTaxes?.find((el) => el.code === value)?.tax)) {
        extraData.otherTaxEuro = parseFloat(SETTINGS.primerMyDataData?.otherTaxes?.find((el) => el.code === value)?.tax).toFixed(2);
      }
    } else if (name === 'withHoldTax') {
      extraData.withHoldTax = value;
      if (!isEmpty(value)
          && SETTINGS.primerMyDataData?.withHoldTaxes?.find((el) => el.code === value)?.taxPer === "false"
          && !isNaN(SETTINGS.primerMyDataData?.withHoldTaxes?.find((el) => el.code === value)?.tax)
          && !isEmpty(SETTINGS.primerMyDataData?.withHoldTaxes?.find((el) => el.code === value)?.tax)) {
        extraData.witholdTaxEuro = parseFloat(SETTINGS.primerMyDataData?.withHoldTaxes?.find((el) => el.code === value)?.tax).toFixed(2);
      }
    } else if (name === 'fee') {
      extraData.fee = value;
      if (!isEmpty(value)
          && SETTINGS.primerMyDataData?.fees?.find((el) => el.code === value)?.taxPer === "false"
          && !isNaN(SETTINGS.primerMyDataData?.fees?.find((el) => el.code === value)?.tax)
          && !isEmpty(SETTINGS.primerMyDataData?.fees?.find((el) => el.code === value)?.tax)) {
        extraData.feeEuro = parseFloat(SETTINGS.primerMyDataData?.fees?.find((el) => el.code === value)?.tax).toFixed(2);
      }
    } else if (name === 'stamp') {
      extraData.stamp = value;
      if (!isEmpty(value)
          && SETTINGS.primerMyDataData?.stamp?.find((el) => el.code === value)?.taxPer === "false"
          && !isNaN(SETTINGS.primerMyDataData?.stamp?.find((el) => el.code === value)?.tax)
          && !isEmpty(SETTINGS.primerMyDataData?.stamp?.find((el) => el.code === value)?.tax)) {
        extraData.stampEuro = parseFloat(SETTINGS.primerMyDataData?.stamp?.find((el) => el.code === value)?.tax).toFixed(2);
      }
    } else if (name === "withHoldTaxAsLine") {
      if (value === "true") {
        if (!isEmpty(SETTINGS.primerMyDataData?.withHoldTaxes?.find((el) => el.code === extraData.withHoldTax)?.name) && isEmpty(extraData?.withHoldTaxAsLineText)) {
          extraData.withHoldTaxAsLineText = SETTINGS.primerMyDataData?.withHoldTaxes?.find((el) => el.code === extraData.withHoldTax)?.name;
        }
      }
    } else if (name === "otherTaxAsLine") {
      if (value === "true") {
        if (!isEmpty(SETTINGS.primerMyDataData?.otherTaxes?.find((el) => el.code === extraData.otherTax)?.name) && isEmpty(extraData?.otherTaxAsLineText)) {
          extraData.otherTaxAsLineText = SETTINGS.primerMyDataData?.otherTaxes?.find((el) => el.code === extraData.otherTax)?.name;
        }
      }
    } else if (name === "feeAsLine") {
      if (value === "true") {
        if (!isEmpty(SETTINGS.primerMyDataData?.fees?.find((el) => el.code === extraData.fee)?.name) && isEmpty(extraData?.feeAsLineText)) {
          extraData.feeAsLineText = SETTINGS.primerMyDataData?.fees?.find((el) => el.code === extraData.fee)?.name;
        }
      }
    } else if (name === "stampAsLine") {
      if (value === "true") {
        if (!isEmpty(SETTINGS.primerMyDataData?.stamp?.find((el) => el.code === extraData.stamp)?.name) && isEmpty(extraData?.stampAsLineText)) {
          extraData.stampAsLineText = SETTINGS.primerMyDataData?.stamp?.find((el) => el.code === extraData.stamp)?.name;
        }
      }
    } else if (name === "deductionsAsLine") {
      if (value === "true" && isEmpty(extraData.deductionsAsLineText)) {
        extraData.deductionsAsLineText = "Γενικές κρατήσεις"
      }
    } else if (name === "isRegime4200") {
      if (value === "true") {
        extraData.isTriangularTrade = "false";
      }
    } else if (name === "isTriangularTrade") {
      if (value === "true") {
        extraData.isRegime4200 = "false";
      }
    }

    let productTotals = getSalesTotals(SALES.newSales.products, SETTINGS);
    let productSalesTaxes = getSalesTaxesData(SALES.newSales.products, extraData, productTotals, SETTINGS);
    productSalesTaxes.map((salesTax) => {
      if(salesTax.vatPercentage === "Invoice Level Tax"){
        extraData.witholdTaxEuro = salesTax.withholdTaxes;
        extraData.withHoldTaxEuro = salesTax.withholdTaxes;
        extraData.otherTaxEuro = salesTax.otherTaxes;
        extraData.feeEuro = salesTax.fees;
        extraData.stampEuro = salesTax.stamp;
      }
      return salesTax;
    })
    let totalTaxes = 0;
    let withHoldTaxes = 0;
    let deductions = 0;
    if(productSalesTaxes.length > 0 && productSalesTaxes[0].vatPercentage === "Invoice Level Tax"){
      totalTaxes = parseFloat( (Number(productSalesTaxes[0].otherTaxes) + Number(productSalesTaxes[0].fees) + Number(productSalesTaxes[0].stamp)).toString());
      withHoldTaxes = parseFloat(productSalesTaxes[0].withholdTaxes).toFixed(2);
      deductions = parseFloat(productSalesTaxes[0].deductions).toFixed(2);
    }
    if(totalTaxes !== 0 || withHoldTaxes !== 0 || deductions !== 0){
      productTotals.paymentAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes) - parseFloat(withHoldTaxes) - parseFloat(deductions)).toFixed(2);
      productTotals.totalAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes)).toFixed(2);
    }
    dispatch(setNewSales({ ...SALES.newSales,salesTaxes: productSalesTaxes, ...productTotals, extraData: extraData }));
    //dispatch(setNewSalesExtraData(extraData));
  }

  const quickClientFields = [
    {
      name: t('SalesNew.quickClientTable.name'),
      field: "name",
      editable: true,
      inputType: {
        type: "text",
      },
    },
    {
      name: t('SalesNew.quickClientTable.vatCategory'),
      field: "vatCategory",
      editable: true,
      inputType: {
        options: getVatCategoryOptions(),
        type: 'select',
      }
    },
    {
      name: t('SalesNew.quickClientTable.vatNumber'),
      field: "vatNumber",
      editable: true,
      inputType: {
        type: "text",
      },
    },
    {
      name: "ΑΜΚΑ Ασθενή",
      field: "amka",
      hidden: SALES.newSales?.clientCategoryName !== "Patient",
      editable: true,
      inputType: {
        type: "text",
      },
    },
    {
      name: t('SalesNew.quickClientTable.phone'),
      field: "phone",
      editable: true,
      inputType: {
        type: "text",
      },
    },
    {
      name: t('SalesNew.quickClientTable.email'),
      field: "email",
      editable: true,
      inputType: {
        type: "text",
      },
    },
    {
      name: t('SalesNew.quickClientTable.address'),
      field: "address",
      editable: true,
      inputType: {
        type: "text",
      },
    },
    {
      name: t('SalesNew.quickClientTable.city'),
      field: "city",
      editable: true,
      inputType: {
        type: "text",
      },
    },
  ];

  const [updateSaleAmounts, setUpdateSaleAmounts] = useState(false);

  const salesProductListActions = {
    insert: async (e, data, currentState = null) => {
      if (!ACTIVITY.saveSales) dispatch(setSaveSales(true));
      let currentSalesState = currentState ? currentState : SALES.newSales;

      let productData = null;
      // Get Product By Code
      if (data && data?.field === 'code') {
        await axios.get(process.env.REACT_APP_API_URL2 + `/category/get-product-by-code/${encodeURIComponent(data.value)}`, {params: company})
            .then(res => {
              if (res.data && res.data.data && (res.data.data?.length > 0) && res.data.status === '200') {
                productData = res.data.data['0'];
              }
            }).catch((err) => {
              console.log(err);
            })
      }
      // Get Product By Name
      if (data && data?.field === 'name') {
        await axios.get(process.env.REACT_APP_API_URL2 + `/category/get-product-by-name/${encodeURIComponent(data.value)}`,{params :company})
            .then(res => {
              if (res.data && res.data.data && (res.data.data?.length > 0) && res.data.status === '200') {
                productData = res.data.data['0'];
              }
            }).catch((err) => {
              console.log(err);
            })
      }
      // Get Product By _id (used in dcl)
      if (data && data?.field === 'productId') {
        await axios.get(process.env.REACT_APP_API_URL2 + `/category/get-product-by-id/${encodeURIComponent(data.value)}`)
            .then(res => {
              if (res.data && res.data.data && res.data.status === '200') {
                productData = res.data.data;
              }
            }).catch((err) => {
              console.log(err);
            })
      }
      if (productData !== null && Object.keys(productData).length > 0) {
        if (e.key !== "Enter") {
          setProductTableSpinner('true');
          let tempNewProduct = Object.assign({}, SALES.newSalesNewProduct);

          tempNewProduct.packagingQuantity = productData.packagingQuantity || 0;
          tempNewProduct.packagingType = productData.packagingType || "1";
          tempNewProduct.otherPackagingTypeTitle = productData.otherPackagingTypeTitle || "";

          // Get Current Product Details with the API if product and client are selected.
          if (currentSalesState.client && currentSalesState.client !== '') {
            await axios.post(`${process.env.REACT_APP_API_URL2}/category/get-product-code-by-price`, { _id: productData._id, client: currentSalesState.client, company: company.id })
                .then((res) => {
                  if (res.data.status === "200") {
                    let pldata = res.data?.data;
                    productData.vatIncluded = pldata.vatIncluded;
                    tempNewProduct.isPerDiscount = pldata.isPerDiscount;
                    tempNewProduct.isDiscountAmount = pldata.isDiscountAmount;
                    tempNewProduct.discount = pldata.discount;

                    productData.price = pldata.productPrice;
                    productData.unitPrice = filterNaNValue(pldata.productPrice);
                  }
                }).catch((error) => {
                  setProductTableSpinner('false');
                  console.log(error);
                })
          }
          if (currentSalesState.enablePeppol === "active") {
            if (productData.cpvCode) {
              tempNewProduct.cpvCode = productData.cpvCode;
            } else {
              tempNewProduct.cpvCode = undefined;
            }
            tempNewProduct.peppolMeasurementUnit = classicInternationalMeasurementUnits[String(productData.measurementUnit)]
            if (isEmpty(tempNewProduct.peppolMeasurementUnit)) tempNewProduct.peppolMeasurementUnit = "H87";
          }
          if (currentSalesState.fuelInvoice === "active") {
            tempNewProduct.fuelCode = productData.fuelCode;
          }
          if (productData?.invoiceDetailType) {
            tempNewProduct.invoiceDetailType = productData.invoiceDetailType;
          } else {
            tempNewProduct.invoiceDetailType = undefined;
          }
          if (productData?.discountOption) {
            tempNewProduct.discountOption = true;
          } else {
            tempNewProduct.discountOption = undefined;
          }
            if (currentSalesState?.isDeliveryNote === "active" || ["9.1", "9.2", "9.3"].includes(currentSalesState?.myDataType)) {
                if (productData?.taricNumber && productData?.measurementUnit !== "4") {
                    tempNewProduct.taricNumber = productData.taricNumber;
                } else {
                    tempNewProduct.taricNumber = undefined;
                }
            }
          if (productData?.specialOption) {
            tempNewProduct.specialOption = productData.specialOption;
          }
            if (productData?.notVAT195) {
                tempNewProduct.notVAT195 = productData.notVAT195;
            }
          if (productData?.showAlternativeNameOnPrint === "true") {
            tempNewProduct.showAlternativeNameOnPrint = "true";
            tempNewProduct.alternativeName = productData.alternateName;
          }
          if (productData?.showAlternativeCodeOnPrint === "true") {
            tempNewProduct.showAlternativeCodeOnPrint = "true";
            tempNewProduct.alternativeCode = productData.alternateCode;
          }
          tempNewProduct.name = productData?.name;
          tempNewProduct.code = productData?.code;
          tempNewProduct.quantity = 1;
          tempNewProduct.mu = productData?.measurementUnit;
          tempNewProduct.muLabel = getLabelByValue(measurementUnitOptions, productData?.measurementUnit.toString(), 'value');
          tempNewProduct.discount = 0;
          tempNewProduct.taxes = 0;
          if (!isEmpty(productData?.deductionsEuro) && parseFloat(productData?.deductionsEuro) > 0) {
            tempNewProduct.deductionsEuro = Number(parseFloat(productData?.deductionsEuro).toFixed(2));
          }
          if (productData?.vatIncluded === "true") {
            const price = parseFloat(productData.price);
            const vat = isNaN(productData.vat) ? 0 : parseFloat(productData.vat);
            if (vat > 0) {
              tempNewProduct.unitPrice = Number(Number(price/(1 + vat/100)).toFixed(2));
            } else {
              tempNewProduct.unitPrice = parseNumber(productData.price);
            }
          } else {
            tempNewProduct.unitPrice = parseNumber(productData.price); // Direct price from the product preferred price
          }
          tempNewProduct[data.field] = data.value; // Updates from table edit
          if (data.field === 'isPerDiscount' && (data.value === "on" || data.value === "true")) {
            tempNewProduct.isPerDiscount = "true";
            tempNewProduct.isDiscountAmount = "false";
          }
          if (data.field === 'isDiscountAmount' && (data.value === "on" || data.value === "true")) {
            tempNewProduct.isPerDiscount = "false";
            tempNewProduct.isDiscountAmount = "true";
          }
          // Fix for loading calculation on insert
          let discountType = 'euro';
          if (tempNewProduct.isPerDiscount === 'true') {
            discountType = 'per';
          }
          const myDataData = productData.mydata.filter(myData => String(myData.invoiceType) === String(currentSalesState.myDataType) && (isEmpty(myData.rowType) || myData.rowType === "income" || (myData.rowType === "expense" && currentSalesState.myDataType === "1.5")));
          if(productData?.isTaxLine === "true"){
            tempNewProduct.vatPercentage  = getVatPercent(clientVatCategory, productData.vat, clientCustomVat);
            if (clientVatCategory === "Reduced VAT" && ["24", "13", "6"].includes(String(productData.vat))) {
              tempNewProduct.vatId = getDefaultOptionByValue(vatCategoryData, String(tempNewProduct.vatPercentage), 'percentage', 'code', 'percentage').label;
            } else if (clientVatCategory === "Zero VAT") {
              tempNewProduct.vatId = "7";
            } else {
              tempNewProduct.vatId = getDefaultOptionByValue(vatCategoryData, productData?.vat, 'percentage', 'code', 'percentage').label;
            }
            tempNewProduct.vatReason      = clientVatReason !== "" ? clientVatReason : productData?.vatReason;
            tempNewProduct.unitPrice      = getPriceExclusiveVat(tempNewProduct.unitPrice, tempNewProduct?.vatPercentage, tempNewProduct.vatIncluded);
            tempNewProduct.discount       = getDiscountExclusiveVat(tempNewProduct.discount, tempNewProduct?.vatPercentage, tempNewProduct.vatIncluded, discountType);
            tempNewProduct.netValue       = 0;
            tempNewProduct.withHoldTax    = productData.withholdTax;
            tempNewProduct.otherTax       = productData.otherTaxes;
            tempNewProduct.stamp          = productData.stamp;
            tempNewProduct.fee           = productData.fee;
            tempNewProduct._id            = productData._id;
            tempNewProduct.isTaxLine      = productData.isTaxLine;
            if( myDataData.length > 0) {
              tempNewProduct.classificationCategory = myDataData[0].category;
              tempNewProduct.classificationType = myDataData[0].type;
              if(myDataData[0]?.vatExpenseType) {
                tempNewProduct.vatExpenseType = myDataData[0].vatExpenseType;
              }
            } else {
              tempNewProduct.classificationCategory = '';
              tempNewProduct.classificationType = '';
              tempNewProduct.vatExpenseType = '';
            }
            tempNewProduct.isTaxLineWithoutVat      = productData.isTaxLineWithoutVat;
            tempNewProduct.taxes          = getNetValue(tempNewProduct.unitPrice, tempNewProduct.quantity, tempNewProduct.discount, discountType);
            tempNewProduct.otherTaxEuro   = getProductOtherTax(tempNewProduct, SETTINGS);
            tempNewProduct.witholdTaxEuro = getProductWithholdTax(tempNewProduct, SETTINGS);
            tempNewProduct.feeEuro        = getProductFee(tempNewProduct, SETTINGS);
            tempNewProduct.stampEuro      = getProductStamp(tempNewProduct, SETTINGS);
            tempNewProduct.vat            = getVatValue(tempNewProduct.taxes, tempNewProduct.vatPercentage);
            tempNewProduct.totalValue     = getTotalValue(tempNewProduct.netValue, tempNewProduct.vatPercentage, tempNewProduct.taxes);
          } else {
            tempNewProduct.vatPercentage = getVatPercent(clientVatCategory, productData.vat, clientCustomVat);
            if (clientVatCategory === "Reduced VAT" && ["24", "13", "6"].includes(String(productData.vat))) {
              tempNewProduct.vatId = getDefaultOptionByValue(vatCategoryData, String(tempNewProduct.vatPercentage), 'percentage', 'code', 'percentage').label;
            } else if (clientVatCategory === "Zero VAT") {
              tempNewProduct.vatId = "7";
            } else {
              tempNewProduct.vatId = getDefaultOptionByValue(vatCategoryData, productData?.vat, 'percentage', 'code', 'percentage').label;
            }
            tempNewProduct.vatReason = clientVatReason !== "" ? clientVatReason : productData?.vatReason;
            tempNewProduct.unitPrice = getPriceExclusiveVat(tempNewProduct.unitPrice, tempNewProduct?.vatPercentage, tempNewProduct.vatIncluded);
            tempNewProduct.discount = getDiscountExclusiveVat(tempNewProduct.discount, tempNewProduct?.vatPercentage, tempNewProduct.vatIncluded, discountType);
            tempNewProduct.netValue = getNetValue(tempNewProduct.unitPrice, tempNewProduct.quantity, tempNewProduct.discount, discountType);
            tempNewProduct.withHoldTax = productData.withholdTax;
            tempNewProduct.otherTax = productData.otherTaxes;
            tempNewProduct.fee = productData.fee;
            tempNewProduct.stamp = productData.stamp;
            tempNewProduct._id = productData._id;
            if(myDataData.length > 0){
              tempNewProduct.classificationCategory = myDataData[0].category;
              tempNewProduct.classificationType = myDataData[0].type;
              if(myDataData[0]?.vatExpenseType) {
                tempNewProduct.vatExpenseType = myDataData[0].vatExpenseType;
              }
            } else {
              tempNewProduct.classificationCategory = '';
              tempNewProduct.classificationType = '';
              tempNewProduct.vatExpenseType = '';
            }
            tempNewProduct.taxes = getTaxes(tempNewProduct, SETTINGS);
            tempNewProduct.otherTaxEuro = getProductOtherTax(tempNewProduct, SETTINGS);
            tempNewProduct.witholdTaxEuro = getProductWithholdTax(tempNewProduct, SETTINGS);
            tempNewProduct.feeEuro = getProductFee(tempNewProduct, SETTINGS);
            tempNewProduct.stampEuro        = getProductStamp(tempNewProduct, SETTINGS);
            if (productData.vatIncluded === "true") {
              let price = isNaN(Number(productData.price)) ? 0 : productData.price;
              tempNewProduct.vat = getVatValue(tempNewProduct.netValue, tempNewProduct.vatPercentage, price);
              tempNewProduct.totalValue = getTotalValue(tempNewProduct.netValue, tempNewProduct.vatPercentage, tempNewProduct.taxes, tempNewProduct.vat);
            } else {
              tempNewProduct.vat = getVatValue(tempNewProduct.netValue, tempNewProduct.vatPercentage);
              tempNewProduct.totalValue = getTotalValue(tempNewProduct.netValue, tempNewProduct.vatPercentage, tempNewProduct.taxes);
            }
          }
          // If validated fields done add new row
          let oldSalesProducts = currentSalesState.products;
          let updatePriceListNewProduct = Object.assign({}, tempNewProduct);
          updatePriceListNewProduct.name = tempNewProduct.name;
          updatePriceListNewProduct.code = tempNewProduct.code;
          updatePriceListNewProduct.no = oldSalesProducts.length + 1;
          updatePriceListNewProduct.id = oldSalesProducts.length + 1;
          updatePriceListNewProduct._id = tempNewProduct._id
          dispatch(setNewSalesNewProduct(tempNewProduct)); // Update redux
          let pPlroducts = [...oldSalesProducts, updatePriceListNewProduct];
          let productTotals = getSalesTotals(pPlroducts, SETTINGS);
          let productSalesTaxes = getSalesTaxesData(pPlroducts, currentSalesState.extraData, productTotals, SETTINGS);
          const autoPackings = generatePackingsFromProducts(pPlroducts);
          let extraData = {...currentSalesState.extraData};
          if(productSalesTaxes.length > 0){
            productSalesTaxes.map((salesTax) => {
              if(salesTax.vatPercentage === "Invoice Level Tax"){
                extraData.witholdTaxEuro = salesTax.withholdTaxes;
                extraData.otherTaxEuro = salesTax.otherTaxes;
                extraData.feeEuro = salesTax.fees;
                extraData.stampEuro = salesTax.stamp;
              }
              return salesTax;
            })
          }
          let totalTaxes = 0;
          let withHoldTaxes = 0;
          let deductions = 0;
          if(productSalesTaxes.length > 0 && productSalesTaxes[0].vatPercentage === "Invoice Level Tax"){
            totalTaxes = parseFloat( (Number(productSalesTaxes[0].otherTaxes) + Number(productSalesTaxes[0].fees) + Number(productSalesTaxes[0].stamp)).toString());
            withHoldTaxes = parseFloat(productSalesTaxes[0].withholdTaxes).toFixed(2);
            deductions = parseFloat(productSalesTaxes[0].deductions).toFixed(2);
          }
          if(totalTaxes !== 0 || withHoldTaxes !== 0 || deductions !== 0){
            productTotals.paymentAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes) - parseFloat(withHoldTaxes) - parseFloat(deductions)).toFixed(2);
            productTotals.totalAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes)).toFixed(2);
          }
          dispatch(setNewSalesNewProduct(SALES.newSalesNewProductInitialValue)); // Reset new category mydata
          if(!isEmpty(currentState)) {
            setProductTableSpinner('false');
            return { ...currentSalesState, products: pPlroducts, packingsDeclarations: autoPackings, salesTaxes: productSalesTaxes, ...productTotals, extraData: extraData };
          } else {
            dispatch(setNewSales({ ...currentSalesState, products: pPlroducts, packingsDeclarations: autoPackings, salesTaxes: productSalesTaxes, ...productTotals, extraData: extraData }));
          }
        }
      }
      setProductTableSpinner('false');
    },
    update: async (data, id, rowIndex, e, currentState = null) => {
      // Set if editing the form
      if (!ACTIVITY.saveSales) dispatch(setSaveSales(true));

      // Set Loading true
      setProductTableSpinner('true');
      let quickEdit = false;
      let foundProduct;
      let productData = null;
      let currentSalesState = currentState ? currentState : SALES.newSales;
      let plProducts = currentSalesState.products.slice();

      // Quick Edit Product from the sales product table
      if (data.quickEdit) {
        let qeProduct = await getObjectFromArrayOfObjects(plProducts, id, '_id');
        if (qeProduct.length > 0) {
          data.code = qeProduct['0'].code;
        }
        foundProduct = plProducts.find(item => item._id === id);
      } else {
        foundProduct = plProducts.find(item => item.id === id);
      }
      if(foundProduct.quickEdit === true) quickEdit = true;
      if (data.isPerDiscount !== undefined && (data.isPerDiscount === "on" || data.isPerDiscount === "true" || data.isPerDiscount === true)) {
        data.isPerDiscount = "true";
        data.isDiscountAmount = "false";
      } else if (data.isDiscountAmount !== undefined && (data.isDiscountAmount === "on" || data.isDiscountAmount === "true" || data.isDiscountAmount === true)) {
        data.isPerDiscount = "false";
        data.isDiscountAmount = "true";
      }
      if (data.name && data.name === '') {
        toast.error("Name is mandatory field.");
      } else if (data.code && data.code === '') {
        toast.error("Code is mandatory field.");
      } else {
        if (foundProduct) {
          let papiUrl = process.env.REACT_APP_API_URL2 + `/category/get-product-by-code/${encodeURIComponent(foundProduct.code)}`;
          if (data.code && data.code !== '') {
            papiUrl = process.env.REACT_APP_API_URL2 + `/category/get-product-by-code/${encodeURIComponent(data.code)}`;
          } else if (data.name && data.name !== '') {
            papiUrl = process.env.REACT_APP_API_URL2 + `/category/get-product-by-name/${encodeURIComponent(data.name)}`;
          }
          let loadingProduct = true;
          if (loadingProduct) {
            // Get product data from api.
            await axios.get(papiUrl ,{params: company})
              .then(res => {
                if (res.data && res.data.data && (res.data.data?.length > 0) && res.data.status === '200') {
                  productData = res.data.data['0'];
                }
              }).catch((err) => {
                console.log(err);
              })
          }
          if(data.name || data.code) {
            quickEdit = false;
          }
          if (data.unitPrice) {
            productData.price = data.unitPrice;
          } else if (foundProduct.unitPrice) {
            productData.price = foundProduct.unitPrice;
          }
          // Field auto population on change product
          if (((data.code && data.code !== '') || (data.name && data.name !== ''))) {
            // Get Current Product Details with the API if product and client are selected.
            if (currentSalesState.client && currentSalesState.client !== '') {
              await axios.post(`${process.env.REACT_APP_API_URL2}/category/get-product-code-by-price`, { _id: productData._id, client: currentSalesState.client, company: company.id })
                  .then((res) => {
                    if (res.data.status === "200") {
                      let plProductData = res.data.data;
                      const myDataData = plProductData?.mydata.filter(myData => String(myData.invoiceType) === String(currentSalesState.myDataType));
                      data.vatIncluded = plProductData.vatIncluded; // Vat Type from price table
                      productData.vatIncluded = plProductData.vatIncluded;
                      data.discount = plProductData?.discount;
                      data.isPerDiscount = plProductData?.isPerDiscount;
                      data.isDiscountAmount = plProductData?.isDiscountAmount;
                      data.name = plProductData?.name;
                      data.code = plProductData?.code;
                      if(!quickEdit) data.classificationCategory = myDataData?.length > 0 ? myDataData[0].category : "";
                      if(!quickEdit) data.classificationType = myDataData?.length > 0 ? myDataData[0].type : "";
                      if(!quickEdit) data.vatExpenseType = (myDataData?.length && myDataData[0]?.vatExpenseType) > 0 ? myDataData[0].vatExpenseType : "";
                      data.mu = plProductData?.measurementUnit;
                      data.muLabel = getLabelByValue(measurementUnitOptions, plProductData?.measurementUnit.toString(), 'value');
                      if(!quickEdit) data.vatId = getDefaultOptionByValue(vatCategoryData, productData?.vat, 'percentage', 'code', 'percentage').label;
                      if(!quickEdit) data.vatPercentage = getVatPercent(clientVatCategory, productData.vat, clientCustomVat);
                      if(!quickEdit) data.vatReason = clientVatReason !== "" ? clientVatReason : plProductData?.vatReason;
                      data.unitPrice = filterNaNValue(plProductData.productPrice);
                      productData.price = filterNaNValue(plProductData.productPrice);
                      productData.unitPrice = filterNaNValue(plProductData.productPrice);
                    }
                  }).catch((err) => {
                    console.log(err);
                  })
            }
            data.withHoldTax = productData.withholdTax;
            data.otherTax = productData.otherTaxes;
            data.stamp = productData.stamp;
            data.fee = productData.fee;
          }
          if (productData?.vatIncluded === "true" && (data.name || data.code)) {
            const price = parseFloat(productData.price);
            const vat = isNaN(productData.vat) ? 0 : parseFloat(productData.vat);
            if (vat > 0) {
              data.unitPrice = Number(Number(price/(1 + vat/100)).toFixed(2));
            } else {
              data.unitPrice = parseNumber(productData.price);
            }
          } else {
            data.unitPrice = parseNumber(productData.price);
          }
          // Updated selected product with updated field data.
          foundProduct = { ...foundProduct, ...data }
          if (currentSalesState.enablePeppol === "active") {
            if (productData.cpvCode) {
              foundProduct.cpvCode = productData.cpvCode;
            } else {
              foundProduct.cpvCode = undefined;
            }
            if (!quickEdit) {
              foundProduct.peppolMeasurementUnit = classicInternationalMeasurementUnits[String(productData.measurementUnit)]
              if (isEmpty(foundProduct.peppolMeasurementUnit)) foundProduct.peppolMeasurementUnit = "H87";
            }
          }
          if (currentSalesState.fuelInvoice === "active") {
            foundProduct.fuelCode = productData.fuelCode;
          }
          if (productData?.invoiceDetailType) {
            foundProduct.invoiceDetailType = productData.invoiceDetailType;
          } else {
            foundProduct.invoiceDetailType = undefined;
          }
          if (productData?.discountOption) {
            foundProduct.discountOption = productData.discountOption;
          } else {
            foundProduct.discountOption = undefined;
          }
          if (currentSalesState?.isDeliveryNote === "active" || ["9.1", "9.2", "9.3"].includes(currentSalesState?.myDataType)) {
              if (productData?.taricNumber && productData?.measurementUnit !== "4") {
                  foundProduct.taricNumber = productData.taricNumber;
              } else {
                  foundProduct.taricNumber = undefined;
              }
          }
          if (productData?.specialOption) {
            foundProduct.specialOption = productData.specialOption;
          } else {
            foundProduct.specialOption = undefined;
          }
            if (productData?.notVAT195) {
                foundProduct.notVAT195 = productData.notVAT195;
            } else {
                foundProduct.notVAT195 = undefined;
            }
          if (!quickEdit) {
            if (productData?.showAlternativeNameOnPrint === "true") {
              foundProduct.showAlternativeNameOnPrint = "true";
              foundProduct.alternativeName = productData.alternateName;
            } else {
              foundProduct.showAlternativeNameOnPrint = undefined;
              foundProduct.alternativeName = undefined;
            }
          }
          if (productData?.showAlternativeCodeOnPrint === "true") {
            foundProduct.showAlternativeCodeOnPrint = "true";
            foundProduct.alternativeCode = productData.alternateCode;
          } else {
            foundProduct.showAlternativeCodeOnPrint = undefined;
            foundProduct.alternativeCode = undefined;
          }
          let discountType = 'euro';
          if (foundProduct.isPerDiscount === 'true') {
            discountType = 'per'
          }
          // Note: For inclusive vat the value is reducing by the vat percentage.
          if (data.discount && data.discount !== '') { // on discount field change
            foundProduct.discount = getDiscountExclusiveVat(foundProduct.discount, foundProduct?.vatPercentage, foundProduct.vatIncluded, discountType);
          }
          // Re Calculate Unit price if net value changed
          if (data.netValue && data.netValue !== '' && foundProduct.isTaxLine !== "true") {
            // If user enters value here, you calculate "Unit Price" automatically (based on previous axiom: "Net Value" has to equal: "Quantity" times "Unit Price" minus "Discount")
            foundProduct.unitPrice = getUnitPrice(data.netValue, foundProduct.quantity, foundProduct.discount, discountType);
          } else {
            if(foundProduct.isTaxLine === "true"){
              foundProduct.netValue = 0;
            } else {
              foundProduct.netValue = getNetValue(foundProduct.unitPrice, foundProduct.quantity, foundProduct.discount, discountType);
            }
          }
          foundProduct.witholdTaxEuro = getProductWithholdTax(foundProduct, SETTINGS);
          foundProduct.otherTaxEuro   = getProductOtherTax(foundProduct, SETTINGS);
          foundProduct.feeEuro   = getProductFee(foundProduct, SETTINGS);
          foundProduct.stampEuro   = getProductStamp(foundProduct, SETTINGS);
          if (!isEmpty(productData?.deductionsEuro) && parseFloat(productData?.deductionsEuro) > 0) {
            foundProduct.deductionsEuro = Number(parseFloat(productData?.deductionsEuro).toFixed(2));
          }
          if(foundProduct.isTaxLine === "true"){
            foundProduct.taxes = getNetValue(foundProduct.unitPrice, foundProduct.quantity, foundProduct.discount, discountType);
          } else {
            foundProduct.taxes = getTaxes(foundProduct, SETTINGS);
          }
          // Re Calculate Unit price and net value if total value changed
          let userTotalValInput = 0; // For recalculating vat +-
          if (data.totalValue && data.totalValue !== '') {
            if(foundProduct.isTaxLine === "true"){
              foundProduct.taxes = getNetValueByTotalValue(data.totalValue, foundProduct.vatPercentage, foundProduct.taxes);
              foundProduct.unitPrice = getUnitPrice(foundProduct.taxes, foundProduct.quantity, foundProduct.discount, discountType);
              foundProduct.netValue = 0;
            } else {
              // If user enters value here, you calculate "Unit Price" and "Net Value" automatically (based on axioms: "Net Value" has to equal: "Quantity" times "Unit Price" minus "Discount" and "Total Value" equals: "VAT %" times "Net Value" plus "Net Value")
              foundProduct.netValue = getNetValueByTotalValue(data.totalValue, foundProduct.vatPercentage, foundProduct.taxes);
              foundProduct.unitPrice = getUnitPrice(foundProduct.netValue, foundProduct.quantity, foundProduct.discount, discountType);
            }
            userTotalValInput = data.totalValue;
            //foundProduct.totalValue = getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes);
          } else {
            foundProduct.totalValue = getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes);
          }
          if(foundProduct.isTaxLine === "true"){
            foundProduct.vat = getVatValue(foundProduct.taxes, foundProduct.vatPercentage);
          } else {
            if (foundProduct._id !== productData._id) {
              foundProduct.code = productData.code;
              foundProduct.name = productData.name;
              foundProduct.unitPrice = isNaN(Number(productData.price)) ? 0 : productData.price;
              foundProduct.measurementUnit = productData.measurementUnit;
              foundProduct.netValue = (Number(foundProduct.quantity) * Number(foundProduct.unitPrice)).toFixed(2);
              foundProduct.vatPercentage = !isNaN(productData.vat) ? productData.vat : 0;
              foundProduct.totalValue = productData.vatIncluded === "true" ? getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes, foundProduct.vat) : getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes);
            }
            if (+foundProduct.netValue === 0 && vatCreditTypes.includes(currentSalesState.myDataType) && data.vat) {
              foundProduct.vat = +parseFloat(data.vat).toFixed(2) || 0;
            } else {
              foundProduct.vat = getVatValue(foundProduct.netValue, foundProduct.vatPercentage, userTotalValInput);
            }
          }
          const myDataData = productData.mydata.filter(myData => String(myData.invoiceType) === String(currentSalesState.myDataType) && (isEmpty(myData.rowType) || myData.rowType === "income" || (myData.rowType === "expense" && currentSalesState.myDataType === "1.5")));
          if(productData?.isTaxLine === "true"){
            if(!quickEdit) foundProduct.vatPercentage  = getVatPercent(clientVatCategory, productData.vat, clientCustomVat);
            if(!quickEdit) {
              if (clientVatCategory === "Reduced VAT" && ["24", "13", "6"].includes(String(productData.vat))) {
                foundProduct.vatId = getDefaultOptionByValue(vatCategoryData, String(foundProduct.vatPercentage), 'percentage', 'code', 'percentage').label;
              } else if (clientVatCategory === "Zero VAT") {
                foundProduct.vatId = "7";
              } else {
                foundProduct.vatId = getDefaultOptionByValue(vatCategoryData, productData?.vat, 'percentage', 'code', 'percentage').label;
              }
            }
            if(!quickEdit) foundProduct.vatReason      = clientVatReason !== "" ? clientVatReason : productData?.vatReason;
            foundProduct.discount       = getDiscountExclusiveVat(foundProduct.discount, foundProduct?.vatPercentage, foundProduct.vatType, discountType);
            foundProduct.netValue       = 0;
            foundProduct.withHoldTax    = productData.withholdTax;
            foundProduct.otherTax       = productData.otherTaxes;
            foundProduct.fee           = productData.fee;
            foundProduct.stamp           = productData.stamp;
            foundProduct._id            = productData._id;
            foundProduct.isTaxLine      = productData.isTaxLine;
            if( myDataData.length > 0) {
              if(!quickEdit) foundProduct.classificationCategory = myDataData[0].category;
              if(!quickEdit) foundProduct.classificationType = myDataData[0].type;
              if(!quickEdit && myDataData[0]?.vatExpenseType) foundProduct.vatExpenseType = myDataData[0].vatExpenseType;
            } else {
              foundProduct.classificationCategory = '';
              foundProduct.classificationType = '';
              foundProduct.vatExpenseType = '';
            }

            foundProduct.isTaxLineWithoutVat      = productData.isTaxLineWithoutVat;
            foundProduct.taxes          = getNetValue(foundProduct.unitPrice, foundProduct.quantity, foundProduct.discount, discountType);
            foundProduct.otherTaxEuro   = getProductOtherTax(foundProduct, SETTINGS);
            foundProduct.witholdTaxEuro = getProductWithholdTax(foundProduct, SETTINGS);
            foundProduct.feeEuro        = getProductFee(foundProduct, SETTINGS);
            foundProduct.stampEuro      = getProductStamp(foundProduct, SETTINGS);
            foundProduct.vat            = getVatValue(foundProduct.taxes, foundProduct.vatPercentage);
            foundProduct.totalValue     = getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes);
          } else {
            if(!quickEdit) foundProduct.vatPercentage = getVatPercent(clientVatCategory, productData.vat, clientCustomVat);
            if(!quickEdit) {
              if (clientVatCategory === "Reduced VAT" && ["24", "13", "6"].includes(String(productData.vat))) {
                foundProduct.vatId = getDefaultOptionByValue(vatCategoryData, String(foundProduct.vatPercentage), 'percentage', 'code', 'percentage').label;
              } else if (clientVatCategory === "Zero VAT") {
                foundProduct.vatId = "7";
              } else {
                foundProduct.vatId = getDefaultOptionByValue(vatCategoryData, productData?.vat, 'percentage', 'code', 'percentage').label;
              }
            }
            if(!quickEdit) foundProduct.vatReason = clientVatReason !== "" ? clientVatReason : productData?.vatReason;
            foundProduct.discount = getDiscountExclusiveVat(foundProduct.discount, foundProduct?.vatPercentage, foundProduct.vatIncluded, discountType);
            foundProduct.withHoldTax = productData.withholdTax;
            foundProduct.otherTax = productData.otherTaxes;
            foundProduct.fee = productData.fee;
            foundProduct.stamp = productData.stamp;
            foundProduct._id = productData._id;
            if(myDataData.length > 0){
              if(!quickEdit) foundProduct.classificationCategory = myDataData[0].category;
              if(!quickEdit) foundProduct.classificationType = myDataData[0].type;
              if(!quickEdit && myDataData[0]?.vatExpenseType) foundProduct.vatExpenseType = myDataData[0].vatExpenseType;
            } else {
              foundProduct.classificationCategory = '';
              foundProduct.classificationType = '';
              foundProduct.vatExpenseType = '';
            }
            foundProduct.taxes = getTaxes(foundProduct, SETTINGS);
            foundProduct.otherTaxEuro = getProductOtherTax(foundProduct, SETTINGS);
            foundProduct.witholdTaxEuro = getProductWithholdTax(foundProduct, SETTINGS);
            foundProduct.feeEuro = getProductFee(foundProduct, SETTINGS);
            foundProduct.stampEuro        = getProductStamp(foundProduct, SETTINGS);
            if (isEmpty(data.vat)) foundProduct.vat = getVatValue(foundProduct.netValue, foundProduct.vatPercentage, userTotalValInput);
            foundProduct.totalValue = getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes, foundProduct.vat);
          }
          const updatedPmProducts = { ...plProducts[foundProduct.no - 1], ...foundProduct }
          let productSalesTaxes;

          plProducts[foundProduct.no - 1] = updatedPmProducts;
          const finalPackings = generatePackingsFromProducts(plProducts);
          let productTotals = getSalesTotals(plProducts, SETTINGS);
          productSalesTaxes = getSalesTaxesData(plProducts, currentSalesState.extraData, productTotals, SETTINGS);
          let totalTaxes = 0;
          let withHoldTaxes = 0;
          let deductions = 0;
          if(productSalesTaxes.length > 0 && productSalesTaxes[0].vatPercentage === "Invoice Level Tax"){
            totalTaxes = parseFloat( (Number(productSalesTaxes[0].otherTaxes) + Number(productSalesTaxes[0].fees) + Number(productSalesTaxes[0].stamp)).toString());
            withHoldTaxes = parseFloat(productSalesTaxes[0].withholdTaxes).toFixed(2);
            deductions = parseFloat(productSalesTaxes[0].deductions).toFixed(2);
          }
          if(totalTaxes !== 0 || withHoldTaxes !== 0 || deductions !== 0){
            productTotals.paymentAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes) - parseFloat(withHoldTaxes) - parseFloat(deductions)).toFixed(2);
            productTotals.totalAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes)).toFixed(2);
          }
          if(currentState) {
            setRefreshPage(refreshPage + 1); // Refresh page
            setProductTableSpinner('false');
            return { ...currentSalesState, products: plProducts, packingsDeclarations: finalPackings, salesTaxes: productSalesTaxes, ...productTotals };
          } else {
            dispatch(setNewSales({ ...currentSalesState, products: plProducts, packingsDeclarations: finalPackings, salesTaxes: productSalesTaxes, ...productTotals })); // update data
          }
          setRefreshPage(refreshPage + 1); // Refresh page

          if (productSalesTaxes.length > 0){
            productSalesTaxes.map((salesTax) => {
              if(salesTax.vatPercentage === "Invoice Level Tax"){
                let extraData = {};
                extraData.witholdTaxEuro = salesTax.withholdTaxes;
                extraData.otherTaxEuro = salesTax.otherTaxes;
                extraData.feeEuro = salesTax.fees;
                extraData.stampEuro = salesTax.stamp;
                dispatch(setNewSalesExtraData({ ...currentSalesState.extraData, ...extraData }));
              }
              return salesTax;
            })
          }
          setProductTableSpinner('false');
        }
      }
    },
    selected: () => {},
    delete: (id, rowIndex) => {
      if (!ACTIVITY.saveSales) dispatch(setSaveSales(true));

      let cloneProducts = structuredClone(SALES.newSales.products);
      cloneProducts.splice(rowIndex, 1);
      cloneProducts.forEach((prod, idx) => {
        prod.no = idx + 1;
        prod.id = String(idx + 1);
      });

      const remainingPackings = generatePackingsFromProducts(cloneProducts);
      dispatch(setNewSales({
        ...SALES.newSales,
        products: cloneProducts,
        packingsDeclarations: remainingPackings
      }));
      setUpdateSaleAmounts(true);
    }
  }


  const selectedDocumentType = getDefaultOptionByValue(documentTypesOptions, SALES.newSales.documentType, 'value', 'label', 'value');
  // const selectedCorelatedDocument = getDefaultOptionByValue(corelatedDocumentOptions, SALES.newSales.corelatedDocument, 'value', 'label', 'value');

  let tableWrClasses = "product-form sales-products-list position-relative";

  if (SALES.newSales.client !== '') {
    tableWrClasses += " normalIndex";
  }

  const [incrKey, setIncrKey] = useState(0);
  useEffect(() => {
    setIncrKey(incrKey + 1);
  }, [SALES.newSales.products, salesProductList])

  const [incrKey2, setIncrKey2] = useState(0);
  useEffect(() => {
    setIncrKey2(incrKey2 + 1);
  }, [SALES.newSales.products, salesProductList, SALES.newSales.extraData])

  const [incrKey3, setIncrKey3] = useState(0);
  useEffect(() => {
    setIncrKey3(incrKey3 + 1);
  }, [SALES.newSales?.otherCorrelatedInvoices, otherCorrelatedInvoicesDefaultData])

  let cashRegistersData = CASH_DATA.cashRegisters.filter((register) => register.isActive === "active");
  let cashRegisterOptions = [{value: "", label: t("General.empty")}, ...getOptionsByData(cashRegistersData, "_id", "name")];
  const specialInvoiceCategoryOptions = getSpecialCategoryOptions("");

  const newSalesTab = [
    {
      tabName: t('SalesNew.productTable.title'),
      tabData: (
          <React.Fragment>
            <Row className={tableWrClasses}>
              <Col md={12}>
                {(SALES.newSales.client === '' && SALES.newSales.newClient === '') && <div className="overlay_w">{t('SalesNew.message2')}</div>}
                {showProductTableSpinner && showProductTableSpinner === 'true' && <div className="overlay_w"> <div className="spinner-border" role="status"> <span className="sr-only">{t("SalesNew.loading")}</span> </div> </div>}
                {SALES.newSales?.products && SALES.newSales?.products?.length === 0 && <span className="text-danger">{t('SalesNew.messageProductList')}</span>}
                <EditableTable
                    tableName="Sales Products List"
                    key={"Sales Products List" + incrKey}
                    actionButtons={{
                      print: false,
                      delete: true,
                      export: false,
                      edit: true,
                    }}
                    columns={clientProductsColumns}
                    pRequestData={pRequestData}
                    data={SALES.newSales.products}
                    allowInsertRow={true}
                    onUpdate={salesProductListActions}
                    allowActions={true}
                    allowToggleColumns={false}
                    allowPrintResults={false}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12} className={"d-flex justify-content-end"}>
                {SALES.newSales?.discountAsLine === true && (
                    <div className={"mt-1 mr-3 text-muted"}>(*) Η έκπτωση θα προβληθεί ως γραμμή παραστατικού με περιγραφή: {SALES.newSales?.discountAsLineText}</div>
                )}
                <Button size={"sm"} onClick={() => setShowDiscountModal(true)}>Εφαρμογή Έκπτωσης</Button>
              </Col>
            </Row>
          </React.Fragment>
      ),
    },
    {
      tabName: t('SalesNew.extraDataTable.title'),
      tabData: (
          <>
            <Row>
              <Col sm={12} md={3} className="mb-2">
                {SALES.newSales.myDataType !== "2.1" && SALES.newSales.myDataType !== "2.2" && SALES.newSales.myDataType !== "2.3" && SALES.newSales.myDataType !== "2.4" && SALES.newSales.myDataType !== "11.2" && SALES.newSales.myDataType !== "7.1" && SALES.newSales.myDataType !== "8.1" && SALES.newSales.myDataType !== "8.2" && (
                    <Dropdown
                        label={t('SalesNew.extraDataTable.locationDelivery')}
                        key={Math.random()}
                        defaultValue={getDefaultOptionByValue(salesLocationData, SALES.newSales.extraData.deliveryLocation, 'value', 'label', 'value')}
                        name="deliveryLocation"
                        options={salesLocationData}
                        onChange={(e) => handleOnChangeExtraData(e, 'dd', 'deliveryLocation')}
                    />
                )}
              </Col>
              {SALES.newSales.extraData.deliveryLocation === "custom" && (
                  <Row className="border-bottom mb-2">
                    <Col sm={12} md={3} className="mb-2">
                      <Dropdown
                          label={t('SalesNew.extraDataTable.locationCountry.locationCountry')}
                          key={Math.random()}
                          defaultValue={getDefaultOptionByValue(countryData, SALES.newSales.extraData.locationCountry, 'value', 'label', 'value')}
                          name="locationCountry"
                          required={true}
                          options={countryData}
                          onChange={(e) => handleOnChangeExtraData(e, 'dd', 'locationCountry')}
                      />
                      {ACTIVITY.saveSales && isEmpty(SALES.newSales.extraData.locationCountry) && (
                          <div className="text-danger">{t('SalesNew.extraDataTable.locationCountry.required')}</div>
                      )}
                    </Col>
                    <Col sm={12} md={3} className="mb-2">
                      <Input
                          label={t('SalesNew.extraDataTable.locationCity.locationCity')}
                          value={SALES.newSales.extraData.locationCity}
                          name="locationCity"
                          type="text"
                          autoComplete={"off"}
                          onChange={(e) => handleOnChangeExtraData(e)}
                      />
                      {ACTIVITY.saveSales && isEmpty(SALES.newSales.extraData.locationCity) && (
                          <div className="text-danger">{t('SalesNew.extraDataTable.locationCity.required')}</div>
                      )}
                    </Col>
                    <Col sm={12} md={3} className="mb-2">
                      <Input
                          label={t('SalesNew.extraDataTable.locationAddress.locationAddress')}
                          value={SALES.newSales.extraData.locationAddress}
                          name="locationAddress"
                          type="text"
                          autoComplete={"off"}
                          onChange={(e) => handleOnChangeExtraData(e)}
                      />
                      {ACTIVITY.saveSales && isEmpty(SALES.newSales.extraData.locationAddress) && (
                          <div className="text-danger">{t('SalesNew.extraDataTable.locationAddress.required')}</div>
                      )}
                    </Col>
                    <Col sm={12} md={3} className="mb-2">
                      <Input
                          label={t('SalesNew.extraDataTable.locationPostalCode.locationPostalCode')}
                          type="text"
                          value={SALES.newSales.extraData.locationZip}
                          name="locationZip"
                          autoComplete={"off"}
                          onChange={(e) => handleOnChangeExtraData(e)}
                      />
                      {ACTIVITY.saveSales && isEmpty(SALES.newSales.extraData.locationZip) && (
                          <div className="text-danger">{t('SalesNew.extraDataTable.locationPostalCode.required')}</div>
                      )}
                    </Col>
                    <Col md={3} className="mb-2">
                      <Input
                          label={"Α.Φ.Μ. Παραλήπτη"}
                          type={"text"}
                          value={SALES.newSales.extraData.locationVatNumber}
                          name={"locationVatNumber"}
                          autoComplete={"off"}
                          onChange={(e) => handleOnChangeExtraData(e)}
                      />
                      {SALES.newSales.enablePeppol === "active" && (
                          <div>Συμπεριλαμβανομένου το πρόθεμα χώρας, π.χ EL{company.vatNumber}</div>
                      )}
                      {ACTIVITY.saveSales && isEmpty(SALES.newSales.extraData.locationVatNumber) && SALES.newSales.enablePeppol === "active" && (
                          <div className="text-danger">Απαιτείται Α.Φ.Μ. Παραλήπτη.</div>
                      )}
                    </Col>
                    <Col md={3} className="mb-2">
                      <Input
                          label={"Ονομασία Εταιρείας Παράδοσης"}
                          type={"text"}
                          value={SALES.newSales.extraData.locationCompanyName}
                          name={"locationCompanyName"}
                          autoComplete={"off"}
                          onChange={(e) => handleOnChangeExtraData(e)}
                      />
                      {ACTIVITY.saveSales && isEmpty(SALES.newSales.extraData.locationCompanyName) && SALES.newSales.enablePeppol === "active" && (
                          <div className="text-danger">Απαιτείται ονομασία εταιρείας παράδοσης.</div>
                      )}
                    </Col>
                  </Row>
              )}
              <Col sm={12} md={3} className="mb-2">
                <Dropdown
                    label={t('SalesNew.extraDataTable.wayOfSendingGoods')}
                    key={Math.random()}
                    defaultValue={getDefaultOptionByValue(waysOfSendingGoodsOptions, SALES.newSales.extraData.wayOfSendingGoods, 'value', 'label', 'value')}
                    name="wayOfSendingGoods"
                    options={waysOfSendingGoodsOptions}
                    onChange={(e) => handleOnChangeExtraData(e, 'dd', 'wayOfSendingGoods')}
                />
              </Col>
              {SALES.newSales.extraData.deliveryLocation === "custom" && (
                  <Col></Col>
              )}
              <Col sm={12} md={3} className="mb-2">
                {pMDDSettings?.otherTaxes?.find((el) => el.code === SALES.newSales.extraData.otherTax)?.taxPer === "false" ? (
                    <Row>
                      <Col md={7}>
                        <Dropdown
                            label={t('SalesNew.extraDataTable.otherTaxes')}
                            key={Math.random()}
                            defaultValue={getDefaultOptionByValue(otherTaxesOptions, SALES.newSales.extraData.otherTax, 'value', 'label', 'value')}
                            name="otherTax"
                            options={otherTaxesOptions}
                            onChange={(e) => handleOnChangeExtraData(e, 'dd', 'otherTax')}
                        />
                      </Col>
                      <Col md={5}>
                        <label>{"Ποσό λοιπόν φόρων"}</label>
                        <AccountingBox
                            name={"otherTaxEuro"}
                            defaultValue={SALES.newSales.extraData.otherTaxEuro}
                            onBlur={(e) => handleOnChangeExtraData(e, "acb", "otherTaxEuro")}
                        />
                      </Col>
                      <Col md={12}>
                        <BetterCheckBox
                            name={"otherTaxAsLine"}
                            text={"Προβολή ως γραμμή παραστατικού"}
                            checked={SALES.newSales.extraData?.otherTaxAsLine === "true"}
                            onChange={(e) => handleOnChangeExtraData(e, "cb", "otherTaxAsLine")}
                        />
                      </Col>
                      {SALES.newSales.extraData?.otherTaxAsLine === "true" && (
                          <Col md={12}>
                            <Input
                                name={"otherTaxAsLineText"}
                                label={"Όνομα γραμμής λοιπού φόρου"}
                                value={isEmpty(SALES.newSales.extraData?.otherTaxAsLineText) ? "" : SALES.newSales.extraData?.otherTaxAsLineText}
                                onChange={(e) => handleOnChangeExtraData(e, "default", "otherTaxAsLineText")}
                            />
                          </Col>
                      )}
                    </Row>
                ) : (
                    <Dropdown
                        label={t('SalesNew.extraDataTable.otherTaxes')}
                        key={Math.random()}
                        defaultValue={getDefaultOptionByValue(otherTaxesOptions, SALES.newSales.extraData.otherTax, 'value', 'label', 'value')}
                        name="otherTax"
                        options={otherTaxesOptions}
                        onChange={(e) => handleOnChangeExtraData(e, 'dd', 'otherTax')}
                    />
                )}
              </Col>
              <Col sm={12} md={3} className="mb-2">
                {pMDDSettings?.withHoldTaxes?.find((el) => el.code === SALES.newSales.extraData.withHoldTax)?.taxPer === "false" ? (
                    <Row>
                      <Col md={7}>
                        <Dropdown
                            label={t('SalesNew.extraDataTable.withHoldTaxes')}
                            key={Math.random()}
                            defaultValue={getDefaultOptionByValue(withHoldTaxesOptions, SALES.newSales.extraData.withHoldTax, 'value', 'label', 'value')}
                            name="withHoldTax"
                            options={withHoldTaxesOptions}
                            onChange={(e) => handleOnChangeExtraData(e, 'dd', 'withHoldTax')}
                        />
                      </Col>
                      <Col md={5}>
                        <label>{"Ποσό παρακράτησης"}</label>
                        <AccountingBox
                            name={"witholdTaxEuro"}
                            defaultValue={SALES.newSales.extraData.witholdTaxEuro}
                            onBlur={(e) => handleOnChangeExtraData(e, "acb", "witholdTaxEuro")}
                        />
                      </Col>
                      <Col md={12}>
                        <BetterCheckBox
                            name={"withHoldTaxAsLine"}
                            text={"Προβολή ως γραμμή παραστατικού"}
                            checked={SALES.newSales.extraData?.withHoldTaxAsLine === "true"}
                            onChange={(e) => handleOnChangeExtraData(e, "cb", "withHoldTaxAsLine")}
                        />
                      </Col>
                      {SALES.newSales.extraData?.withHoldTaxAsLine === "true" && (
                          <Col md={12}>
                            <Input
                                name={"withHoldTaxAsLineText"}
                                label={"Όνομα γραμμής παρακρατούμενου"}
                                value={isEmpty(SALES.newSales.extraData?.withHoldTaxAsLineText) ? "" : SALES.newSales.extraData?.withHoldTaxAsLineText}
                                onChange={(e) => handleOnChangeExtraData(e, "default", "withHoldTaxAsLineText")}
                            />
                          </Col>
                      )}
                    </Row>
                ) : (
                    <Dropdown
                        label={t('SalesNew.extraDataTable.withHoldTaxes')}
                        key={Math.random()}
                        defaultValue={getDefaultOptionByValue(withHoldTaxesOptions, SALES.newSales.extraData.withHoldTax, 'value', 'label', 'value')}
                        name="withHoldTax"
                        options={withHoldTaxesOptions}
                        onChange={(e) => handleOnChangeExtraData(e, 'dd', 'withHoldTax')}
                    />
                )}
              </Col>
            </Row>
            <Row>
              <Col sm={12} md={3}>
                <DateTimeBox
                    classes="w-100 mb-2"
                    label={t('SalesNew.extraDataTable.goodsSendDate')}
                    name="goodsSendDate"
                    minDate={moment().toDate()}
                    selected={moment(SALES.newSales.extraData.goodsSendDate).isValid() ? moment(SALES.newSales.extraData.goodsSendDate).toDate() : null}
                    onChange={(e) => handleOnChangeExtraData(e, 'dtb', 'goodsSendDate')}
                />
              </Col>
              <Col sm={12} md={3} className="mb-2">
                <Dropdown
                    label={t('SalesNew.extraDataTable.carNumber')}
                    key={Math.random()}
                    defaultValue={getDefaultOptionByValue(carNumbersOptions, SALES.newSales.extraData.carNumber, 'value', 'label', 'value')}
                    name="carNumber"
                    options={carNumbersOptions}
                    onChange={(e) => handleOnChangeExtraData(e, 'dd', 'carNumber')}
                />
              </Col>
              <Col sm={12} md={3} className="mb-2">
                {pMDDSettings?.fees?.find((el) => el.code === SALES.newSales.extraData.fee)?.taxPer === "false" ? (
                    <Row>
                      <Col md={7}>
                        <Dropdown
                            label={t('SalesNew.extraDataTable.fees')}
                            key={Math.random()}
                            defaultValue={getDefaultOptionByValue(feesOptions, SALES.newSales.extraData.fee, 'value', 'label', 'value')}
                            name="fee"
                            options={feesOptions}
                            onChange={(e) => handleOnChangeExtraData(e, 'dd', 'fee')}
                        />
                      </Col>
                      <Col md={5}>
                        <label>{"Ποσό Τέλους"}</label>
                        <AccountingBox
                            name={"feeEuro"}
                            defaultValue={SALES.newSales.extraData.feeEuro}
                            onBlur={(e) => handleOnChangeExtraData(e, "acb", "feeEuro")}
                        />
                      </Col>
                      <Col md={12}>
                        <BetterCheckBox
                            name={"feeAsLine"}
                            text={"Προβολή ως γραμμή παραστατικού"}
                            checked={SALES.newSales.extraData?.feeAsLine === "true"}
                            onChange={(e) => handleOnChangeExtraData(e, "cb", "feeAsLine")}
                        />
                      </Col>
                      {SALES.newSales.extraData?.feeAsLine === "true" && (
                          <Col md={12}>
                            <Input
                                name={"feeAsLineText"}
                                label={"Όνομα γραμμής τέλους"}
                                value={isEmpty(SALES.newSales.extraData?.feeAsLineText) ? "" : SALES.newSales.extraData?.feeAsLineText}
                                onChange={(e) => handleOnChangeExtraData(e, "default", "feeAsLineText")}
                            />
                          </Col>
                      )}
                    </Row>
                ) : (
                    <Dropdown
                        label={t('SalesNew.extraDataTable.fees')}
                        key={Math.random()}
                        defaultValue={getDefaultOptionByValue(feesOptions, SALES.newSales.extraData.fee, 'value', 'label', 'value')}
                        name="fee"
                        options={feesOptions}
                        onChange={(e) => handleOnChangeExtraData(e, 'dd', 'fee')}
                    />
                )}
              </Col>
              <Col sm={12} md={3} className="mb-2">
                {pMDDSettings?.stamp?.find((el) => el.code === SALES.newSales.extraData.stamp)?.taxPer === "false" ? (
                    <Row>
                      <Col md={7}>
                        <Dropdown
                            label={t('SalesNew.extraDataTable.stampDuty')}
                            key={Math.random()}
                            defaultValue={getDefaultOptionByValue(stampOptions, SALES.newSales.extraData.stamp, 'value', 'label', 'value')}
                            name="stamp"
                            options={stampOptions}
                            onChange={(e) => handleOnChangeExtraData(e, 'dd', 'stamp')}
                        />
                      </Col>
                      <Col md={5}>
                        <label>{"Ποσό χαρτοσήμου"}</label>
                        <AccountingBox
                            name={"stampEuro"}
                            defaultValue={SALES.newSales.extraData.stampEuro}
                            onBlur={(e) => handleOnChangeExtraData(e, "acb", "stampEuro")}
                        />
                      </Col>
                      <Col md={12}>
                        <BetterCheckBox
                            name={"stampAsLine"}
                            text={"Προβολή ως γραμμή παραστατικού"}
                            checked={SALES.newSales.extraData?.stampAsLine === "true"}
                            onChange={(e) => handleOnChangeExtraData(e, "cb", "stampAsLine")}
                        />
                      </Col>
                      {SALES.newSales.extraData?.stampAsLine === "true" && (
                          <Col md={12}>
                            <Input
                                name={"stampAsLineText"}
                                label={"Όνομα γραμμής χαρτοσήμου"}
                                value={isEmpty(SALES.newSales.extraData?.stampAsLineText) ? "" : SALES.newSales.extraData?.stampAsLineText}
                                onChange={(e) => handleOnChangeExtraData(e, "default", "stampAsLineText")}
                            />
                          </Col>
                      )}
                    </Row>
                ) : (
                    <Dropdown
                        label={t('SalesNew.extraDataTable.stampDuty')}
                        key={Math.random()}
                        defaultValue={getDefaultOptionByValue(stampOptions, SALES.newSales.extraData.stamp, 'value', 'label', 'value')}
                        name="stamp"
                        options={stampOptions}
                        onChange={(e) => handleOnChangeExtraData(e, 'dd', 'stamp')}
                    />
                )}
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Dropdown
                    name={"cashRegister"}
                    label={t("General.cashRegister")}
                    key={Math.random()}
                    defaultValue={cashRegisterOptions.find((el) => el.value === SALES.newSales.extraData.cashRegister) ? cashRegisterOptions.find((el) => el.value === SALES.newSales.extraData.cashRegister) : ""}
                    options={cashRegisterOptions}
                    onChange={(e) => handleOnChangeExtraData(e, "dd", "cashRegister")}
                />
              </Col>
              <Col md={3}>
                <Dropdown
                    name={"specialInvoiceCategory"}
                    label={"Ειδική Κατηγορία Παραστατικού"}
                    key={Math.random()}
                    defaultValue={specialInvoiceCategoryOptions.find((el) => el.value === SALES.newSales.specialInvoiceCategory) ? specialInvoiceCategoryOptions.find((el) => el.value === SALES.newSales.specialInvoiceCategory) : ""}
                    options={specialInvoiceCategoryOptions}
                    onChange={(e) => handleOnChange(e, "dd", "specialInvoiceCategory")}
                />
              </Col>
              <Col md={3}>
                <label>{"Ποσό κρατήσεων"}</label>
                <AccountingBox
                    name={"deductionsEuro"}
                    defaultValue={SALES.newSales.extraData.deductionsEuro}
                    onBlur={(e) => handleOnChangeExtraData(e, "acb", "deductionsEuro")}
                />
                {SALES.newSales.extraData.deductionsEuro && parseFloat(SALES.newSales.extraData.deductionsEuro) > 0 && (
                    <React.Fragment>
                      <BetterCheckBox
                          name={"deductionsAsLine"}
                          text={"Προβολή ως γραμμή παραστατικού"}
                          checked={SALES.newSales.extraData?.deductionsAsLine === "true"}
                          onChange={(e) => handleOnChangeExtraData(e, "cb", "deductionsAsLine")}
                      />
                      {SALES.newSales.extraData?.deductionsAsLine === "true" && (
                          <Input
                              name={"deductionsAsLineText"}
                              label={"Όνομα γραμμής κράτησης"}
                              value={isEmpty(SALES.newSales.extraData?.deductionsAsLineText) ? "" : SALES.newSales.extraData?.deductionsAsLineText}
                              onChange={(e) => handleOnChangeExtraData(e, "default", "deductionsAsLineText")}
                          />
                      )}
                    </React.Fragment>
                )}
              </Col>
                {SALES.newSales?.reverseDeliveryNotePurpose && (
                    <Col md={3}>
                        <Dropdown
                            name={"reverseDeliveryNotePurpose"}
                            label={"Αιτία Αντίστροφης Διακίνησης"}
                            options={reverseDeliveryNotePurposes}
                            defaultValue={reverseDeliveryNotePurposes.find((el) => el.value === SALES.newSales.reverseDeliveryNotePurpose)}
                            key={SALES.newSales.reverseDeliveryNotePurpose}
                            onChange={(e) => handleOnChange(e, "dd", "reverseDeliveryNotePurpose")}
                        />
                    </Col>
                )}
            </Row>
            {["1.2", "5.1", "5.2"].includes(SALES.newSales.myDataType) && (
                <Row className="mb-2">
                  <Col sm={12} md={3}>
                    <BetterCheckBox
                        name="regime4200"
                        text="Υπόκειται στο καθεστώς 4200 (Έντυπο Φ4)"
                        checked={SALES.newSales.extraData?.isRegime4200 === "true"}
                        onChange={(e) => handleOnChangeExtraData(e, "cb", "isRegime4200")}
                    />
                  </Col>
                  <Col sm={12} md={3}>
                    <BetterCheckBox
                        name="triangularTransaction"
                        text="Αφορά τριγωνική συναλλαγή (Έντυπο Φ4)"
                        checked={SALES.newSales.extraData?.isTriangularTrade === "true"}
                        onChange={(e) => handleOnChangeExtraData(e, "cb", "isTriangularTrade")}
                    />
                  </Col>
                </Row>
            )}
              <Row>
                  {SALES.newSales.specialInvoiceCategory === "4" && (
                      <React.Fragment>
                          <Col md={3}>
                              <Input
                                  className="w-100"
                                  label={"Αριθμός Επίσημου Εγγράφου"}
                                  name={"documentIdNo"}
                                  autoComplete={"off"}
                                  value={SALES.newSales.documentIdNo}
                                  charLimit={100}
                                  onChange={(e) => handleOnChange(e)}
                              />
                          </Col>
                          <Col md={3}>
                              <Dropdown
                                  label={"Χώρα Έκδοσης Επίσημου Εγγράφου"}
                                  name={"countryDocumentId"}
                                  options={countryOptions}
                                  defaultValue={countryOptions.find((el) => el.value === SALES.newSales?.countryDocumentId) || ""}
                                  onChange={(e) => handleOnChange(e, "dd", "countryDocumentId")}
                              />
                          </Col>
                      </React.Fragment>
                  )}
                  {SALES.newSales?.fuelInvoice === "active" && (
                      <Col md={3}>
                          <Input
                              className="w-100"
                              label={"Αριθμός Παροχής Ηλ. Ρεύματος"}
                              name={"supplyAccountNo"}
                              autoComplete={"off"}
                              value={SALES.newSales.supplyAccountNo}
                              charLimit={100}
                              onChange={(e) => handleOnChange(e)}
                          />
                      </Col>
                  )}
              </Row>
            {(SALES.newSales?.isDeliveryNote || SALES.newSales.myDataType === "9.3") && (
                <Row>
                  <Col md={3}>
                    <Dropdown
                        name={"loadingAddressOption"}
                        label={"Τοποθεσία Φόρτωσης Εμπορευμάτων"}
                        options={loadingAddressOptions}
                        defaultValue={loadingAddressOptions.find((el) => el.value === SALES.newSales.extraData.loadingAddressOption)}
                        key={SALES.newSales.extraData.loadingAddressOption}
                        onChange={(e) => handleOnChangeExtraData(e, "dd", "loadingAddressOption")}
                    />
                  </Col>
                  {SALES.newSales.extraData?.loadingAddressOption === "custom" && (
                      <React.Fragment>
                        <Col md={3}>
                          <Input
                              label={"Πόλη Φόρτωσης Εμπορευμάτων"}
                              value={SALES.newSales.extraData.loadingAddressCity}
                              name="loadingAddressCity"
                              type="text"
                              autoComplete={"off"}
                              onChange={(e) => handleOnChangeExtraData(e)}
                          />
                        </Col>
                        <Col md={2}>
                          <Input
                              label={"Τ.Κ. Φόρτωσης Εμπορευμάτων"}
                              value={SALES.newSales.extraData.loadingAddressPostalCode}
                              name="loadingAddressPostalCode"
                              type="text"
                              autoComplete={"off"}
                              onChange={(e) => handleOnChangeExtraData(e)}
                          />
                        </Col>
                        <Col md={2}>
                          <Input
                              label={"Οδός Φόρτωσης Εμπορευμάτων"}
                              value={SALES.newSales.extraData.loadingAddressStreet}
                              name="loadingAddressStreet"
                              type="text"
                              autoComplete={"off"}
                              onChange={(e) => handleOnChangeExtraData(e)}
                          />
                        </Col>
                        <Col md={2}>
                          <Input
                              label={"Αρ. Οδού Φόρτωσης Εμπορευμάτων"}
                              value={SALES.newSales.extraData.loadingAddressNumber}
                              name="loadingAddressNumber"
                              type="text"
                              autoComplete={"off"}
                              onChange={(e) => handleOnChangeExtraData(e)}
                          />
                        </Col>
                      </React.Fragment>
                  )}
                </Row>
            )}
            {["9.1", "9.2", "9.3"].includes(SALES.newSales.myDataType) && (
                <Row>
                  <Col md={4}>
                    <BetterCheckBox
                        name={"toWeigh"}
                        text={"Ένδειξη Δ.Α. προς ζύγιση"}
                        checked={SALES.newSales.toWeigh}
                        onChange={(e) => handleOnChange(e, "checkbox", "toWeigh")}
                    />
                  </Col>
                </Row>
            )}
          </>
      ),
    },
  ];

  const newCorrelatedEntitiesTab = {
    tabName: "Λοιπές Συσχετιζόμενες Οντότητες",
    tabData: (
        <React.Fragment>
          <Row>
            <Col md={3}>
              <Button size={"sm"} onClick={() => setSelectedEntity({
                id: (SALES.newSales.otherCorrelatedEntities.length + 1),
                type: "new",
                country: "GR",
                name: "",
                address: "",
                city: "",
                postalCode: "",
                vatNumber: ""
              })}>+ Προσθήκη νέας οντότητας</Button>
            </Col>
          </Row>
          {SALES.newSales.otherCorrelatedEntities.length > 0 && (
              <Row className="mt-3">
                {SALES.newSales.otherCorrelatedEntities.map((entity, idx) => (
                    <Col md={4} className="mb-3" key={idx + "entity"} onClick={() => setSelectedEntity(entity)}>
                      <div className={"subscription-box subscription-box-permission"}>
                        <div style={{margin: "10px"}}>
                          <span
                              style={{fontWeight: "600"}}>Τύπος: </span>{getOtherCorrelatedEntitiesTypes.find((el) => String(el.value) === String(entity?.type))?.label}<br/>
                          <span style={{fontWeight: "600"}}>Επωνυμία: </span> {entity.name}<br/>
                          <span style={{fontWeight: "600"}}>Α.Φ.Μ.: </span> {entity.vatNumber}<br/>
                          <span
                              style={{fontWeight: "600"}}>Χώρα: </span> {getCountryOptions('all').find((el) => String(el.value) === String(entity?.country))?.label}<br/>
                          {entity?.address && (<><span
                              style={{fontWeight: "600"}}>Διεύθυνση: </span> {entity.address}, {entity.city}, {entity.postalCode}<br/></>)}
                        </div>
                      </div>
                    </Col>
                ))}
              </Row>
          )}
        </React.Fragment>
    )
  }

  // Data For Quick Edit Client Details on selection
  let quickEditClientData = {};
  if (SALES.newSales.clientType === 'Existing') {
    if (SALES.newSales.client && SALES.newSales.client !== "") {
      quickEditClientData.name = SALES.newSales.clientName;
      quickEditClientData.id = SALES.newSales.client;
      quickEditClientData.vatCategory = SALES.newSales.vatCategory;
      quickEditClientData.address = SALES.newSales.address;
      quickEditClientData.vatNumber = String(SALES.newSales.vat).trim();
      quickEditClientData.doy = getLabelByValue(getDOYOptions(), Number(SALES.newSales.doy), 'value');
      quickEditClientData.city = SALES.newSales.city;
      quickEditClientData.amka = SALES.newSales?.amka;
      quickEditClientData.clientCategoryName = SALES.newSales?.clientCategoryName;
      quickEditClientData.clientCategory = SALES.newSales?.clientCategory;
      quickEditClientData.pc = SALES.newSales.pc;
      quickEditClientData.email = SALES.newSales.email;
      quickEditClientData.phone = SALES.newSales.phone;
    }
  }

  const quickEditClient = (e, type, data) => {
    let selectedClient = SALES.newSales.client;
    if (selectedClient) {
      let quickClientData = {};
      // Quick Edit Client Details Data
      quickClientData._id = SALES.newSales.client;
      quickClientData.company = company.id;
      quickClientData.name = data.name;
      quickClientData.vatCategory = data.vatCategory;
      quickClientData.vatNumber = String(data.vatNumber).trim();
      quickClientData.address = data.address;
      quickClientData.city = data.city;
      quickClientData.amka = data?.amka;
      quickClientData.categoryName = data?.clientCategoryName;
      quickClientData.category = data?.clientCategory;
      quickClientData.email = data.email;
      quickClientData.phone = data.phone;

      if (((data.email !== '' || data.phone !== '') && data.clientCategoryName !== "Patient") || (data.clientCategoryName === "Patient" && !isEmpty(data?.amka) && data.name !== '' && data.vatCategory !== '')) {
        dispatch(putClient(quickClientData, requestData));
        // Repopulate the client data to sales after updating the client.
        let sClient = data;
        let repopulateClient = {};
        repopulateClient.clientCategoryName = sClient?.clientCategoryName;
        repopulateClient.clientCategory = sClient?.clientCategory;
        repopulateClient.clientName = sClient.name;
        repopulateClient.address = sClient.address;
        repopulateClient.vat = String(sClient.vatNumber).trim();
        repopulateClient.vatCategory = sClient.vatCategory;
        repopulateClient.city = sClient.city;
        repopulateClient.amka = sClient?.amka;
        repopulateClient.email = sClient.email;
        repopulateClient.pc = sClient.postalCode;
        repopulateClient.phone = sClient.phone;

        let salesData = Object.assign({}, SALES);
        dispatch(setNewSales({ ...salesData.newSales, ...repopulateClient }));

      } else {
        toast.error('Name, Email or Phone and Vat Category required fields.');
      }
    }
  }

  const clearClient = () => {
    if(SALES.newSales.client !== ''){
      let newSalesData = {};
      let salesData = Object.assign({}, SALES);
      newSalesData.client = "";
      newSalesData.clientName = "";
      newSalesData.clientCode = "";
      newSalesData.address = "";
      newSalesData.vat = "";
      newSalesData.doy = "";
      newSalesData.city = "";
      newSalesData.amka = "";
      newSalesData.clientCategoryName = "";
      newSalesData.clientCategory = "";
      newSalesData.country = "";
      newSalesData.pc = "";
      newSalesData.email = "";
      newSalesData.phone = "";
      newSalesData.activity = "";
      newSalesData.vatCategory = "";
      setClientInstallationListData(CLIENTS_DATA.installations.slice());
      newSalesData.clientInstallationType = "";
      newSalesData.clientInstallationId = "";
      // Set Client Vat Category used for product vat calculation
      dispatch(setNewSaleClientCustomData({
        clientVatCategory: "Normal VAT",
        clientVatReason: "",
        clientCustomVat: 0,
      }))
      dispatch(setNewSales({ ...salesData.newSales, ...newSalesData }));
    }
  }

  let posData = CASH_DATA.posList.filter((pos) => pos.isActive === "active");
  let bankData = CASH_DATA.bankAccounts.filter((bankAccount) => bankAccount.isActive === "active");
  let posOptions = getOptionsByData(posData, '_id', 'name');
  let bankOptions = getOptionsByData(bankData, '_id', 'name');
  let hidePosBankField = false;

  // This will update the list of pos / bank on type selection
  let paymentTypesData = getObjectFromArrayOfObjects(SALES_SETTINGS.salesGeneralSettings.paymentTypes, SALES.newSales.paymentType, '_id');
  if (paymentTypesData && paymentTypesData.length > 0) {
    if (paymentTypesData['0']?.type === "pos") {
      bankOptions = posOptions;
    }

    if (paymentTypesData['0']?.type === "cash" || paymentTypesData['0']?.type === "credit" || paymentTypesData['0']?.type === "cheque" || paymentTypesData['0']?.type === "iris") {
      bankOptions = [];
      hidePosBankField = true;
    }
  }
  let salesTaxesColumns = [
    {
      name: t('SalesNew.salesTaxesTables.vat%'),
      field: "vatPercentage",
      width: "15%",
      editable: false,
    },
    {
      name: t('SalesNew.salesTaxesTables.netValue'),
      field: "netValue",
      width: "15%",
      editable: false,
    },
    {
      name: t('SalesNew.salesTaxesTables.vat'),
      field: "vatEuro",
      width: "15%",
      editable: false,
    },
    {
      name: t('SalesNew.salesTaxesTables.withHoldTaxes'),
      field: "withholdTaxes",
      width: "15%",
      editable: false,
    },
    {
      name: t('SalesNew.salesTaxesTables.otherTaxes'),
      field: "otherTaxes",
      width: "10%",
      editable: false,
    },
    {
      name: t('SalesNew.salesTaxesTables.fees'),
      field: "fees",
      width: "10%",
      editable: false,
    },
    {
      name: t('SalesNew.salesTaxesTables.stampDuty'),
      field: "stamp",
      width: "10%",
      editable: false,
    },
    {
      name: "Κρατήσεις",
      field: "deductions",
      width: "10%",
      editable: false,
    }
  ];
  let totalTaxes = 0;
  let withHoldTaxes = 0;
  let deductions = 0;
  let productTotals = useMemo(() => getSalesTotals(SALES.newSales.products, SETTINGS), [SALES.newSales.products]);
  let salesTaxesData = useMemo(() => getSalesTaxesData(SALES.newSales.products,SALES.newSales.extraData, productTotals, SETTINGS), [SALES.newSales.products, SALES.newSales.extraData]);
  if(salesTaxesData.length > 0 && salesTaxesData[0].vatPercentage === "Invoice Level Tax"){
    totalTaxes = parseFloat( (Number(salesTaxesData[0].otherTaxes) + Number(salesTaxesData[0].fees) + Number(salesTaxesData[0].stamp)).toString());
    withHoldTaxes = parseFloat(salesTaxesData[0].withholdTaxes).toFixed(2);
    deductions = parseFloat(salesTaxesData[0].deductions).toFixed(2);
  }
  let totalQuantity = productTotals.totalQuantity;
  let totalBeforeDiscount = productTotals.totalBeforeDiscount;
  let totalDiscount = productTotals.totalDiscount;
  let totalNetValue = productTotals.totalNetValue;
  let totalAmount = productTotals.totalAmount;
  let paymentAmount = productTotals.paymentAmount;
  let totalVatAmount = productTotals.totalVatValue;
  withHoldTaxes = parseFloat(parseFloat(productTotals.withHoldTaxes) + parseFloat(withHoldTaxes));
  if(totalTaxes !== 0 || withHoldTaxes !== 0 || deductions !== 0){
    totalAmount = parseFloat(totalAmount) + parseFloat(totalTaxes);
    paymentAmount = parseFloat(paymentAmount) + parseFloat(totalTaxes) - parseFloat(withHoldTaxes) - parseFloat(deductions);
  }
  totalTaxes += Number(productTotals.totalTaxesAmount);
  const selectDocumentInstallation = getDefaultOptionByValue(dtInstallationsOptions, SALES.newSales.installation, 'value', 'label', 'value');
  const selectPaymentTypeOptions = getDefaultOptionByValue(paymentTypeOptions, SALES.newSales.paymentType, 'value', 'label', 'value');
  const selectPosBankAccount = getDefaultOptionByValue(bankOptions, SALES.newSales.bankAccount, 'value', 'label', 'value');
  const selectSalePurpose = getDefaultOptionByValue(salesPurposeOptions, SALES.newSales.salePurpose, 'value', 'label', 'value');
  const selectPreNumber = getDefaultOptionByValue(preNumberGreekOptions, SALES.newSales.preNumber, 'value', 'label', 'value');

  useEffect(() => {
    if(updateSaleAmounts === true) {
      setUpdateSaleAmounts(false);
      let extraData = {};
      if(salesTaxesData.length > 0) {
        salesTaxesData.forEach((salesTax) => {
          if(salesTax.vatPercentage === "Invoice Level Tax") {
            extraData.witholdTaxEuro = salesTax.withholdTaxes;
            extraData.otherTaxEuro = salesTax.otherTaxes;
            extraData.feeEuro = salesTax.fees;
            extraData.stampEuro = salesTax.stamp;
          }
        })
      }
      dispatch(setNewSales({
        ...SALES.newSales,
        salesTaxes: salesTaxesData,
        extraData: {...SALES.newSales.extraData, ...extraData},
        withHoldTaxes: withHoldTaxes.toFixed(2),
        ...productTotals,
      }))
    }
  }, [updateSaleAmounts]);

  const handleOnPeppolChange = (e, type, name) => {
    let obj = {};
    if (SALES.newSales?.peppol) obj = {...SALES.newSales?.peppol}
    if (type === "input") {
      obj[name] = e.target.value;
      obj.dueDate = moment().format("YYYY-MM-DD");
      dispatch(setNewSales({...SALES.newSales, peppol: obj}));
    } else if (type === "datebox") {
      if (moment(e).isValid()) {
        obj[name] = moment(e).format("YYYY-MM-DD")
      } else {
        obj[name] = ""
      }
      dispatch(setNewSales({...SALES.newSales, peppol: obj}));
    } else if (type === "anathetousaModal") {
      // name argument is object here from select anathetousa modal
      toast.success("Η επιλογή έγινε επιτυχώς", {autoClose: 1000});
      obj["dueDate"] = moment().format("YYYY-MM-DD");
      obj["partyIdentification"] = name.anathetousaLabelId;
      dispatch(setNewSales({...SALES.newSales, peppol: obj}));
    }
  }

  const [loadingCheckPeppolFields, setLoadingCheckPeppolFields] = useState(false);
  const handleCheckPeppolFields = () => {
    if (isEmpty(SALES.newSales?.vat)) {
      toast.error("Παρακαλώ επιλέξτε πελάτη.");
    } else if (isEmpty(SALES.newSales?.peppol?.projectReference) && SALES.newSales.myDataType !== "5.1") {
      toast.error("Παρακαλώ συμπληρώστε Α.Δ.Α. ή Ενάριθμο.");
    } else if (isEmpty(SALES.newSales?.peppol?.partyIdentification)) {
      toast.error("Παρακαλώ συμπληρώστε κωδικό αναθέτουσας αρχής.");
    } else {
      setLoadingCheckPeppolFields(true);
      axios.post(process.env.REACT_APP_API_URL2 + "/sale/check-peppol-fields", {
        projectReferenceId: SALES.newSales?.peppol?.projectReference,
        buyerPartyId: SALES.newSales?.peppol?.partyIdentification,
        buyerTaxNumber: SALES.newSales?.vat,
        contractReferenceId: SALES.newSales?.peppol?.contractDocumentReference ? SALES.newSales?.peppol?.contractDocumentReference : "0",
        company: company.id
      }, {
        headers: { 'Content-Type': 'application/json'}
      }).then((res) => {
        setLoadingCheckPeppolFields(false);
        if (res.data.status === "200") {
          toast.success("Τα πεδία είναι έγκυρα.");
        } else {
          if (res.data.nonValidFields) {
            let prepMessage = `Τα παρακάτω πεδία δεν είναι έγκυρα: ${res.data.nonValidFields.join(", ")}`;
            toast.error(prepMessage, {autoClose: 7000});
          } else {
            toast.error(res.data.message);
          }
        }
      }).catch((err) => {
        setLoadingCheckPeppolFields(false);
        console.log(err);
        toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
      })
    }
  }

  const discountObj = useSelector((state) => state.SALES.salesDiscountObject);
  const discountTypeOptions = [
    {label: "Ποσοστιαία %", value: "percentage"},
    {label: "Ποσό €", value: "amount"}
  ]
  const handleOnDiscountChange = (e, type, name) => {
    if (type === "dropdown") {
      dispatch(setSalesDiscountObject({...discountObj, [name] : e.value, amount: 0}));
    } else if (type === "input") {
      dispatch(setSalesDiscountObject({...discountObj, [name] : e.target.value}));
    } else if (type === "cb") {
      dispatch(setSalesDiscountObject({...discountObj, [name] : e.target.checked}));
    }
  }
  const handleSaveDiscount = () => {
    if (!+SALES.newSales.totalNetValue > 0) return toast.error("Παρακαλώ συμπληρώστε πρώτα τις τιμές.");
    if (isNaN(discountObj.amount)) return toast.error(`Το ${discountObj.discountType === "percentage" ? "ποσοστό" : "ποσό"} δεν είναι δεκτός αριθμός.`);
    if (discountObj.discountAsLine === true && isEmpty(discountObj.discountAsLineText)) return toast.error("Παρακαλώ συμπληρώστε την περιγραφή της έκπτωσης.");

    let toApplyAmount = 0;
    if (discountObj.discountType === "percentage") {
      toApplyAmount = +Number((discountObj.amount / 100) * +SALES.newSales.totalNetValue).toFixed(2);
    } else if (discountObj.discountType === "amount") {
      toApplyAmount = +Number(discountObj.amount * (+SALES.newSales.totalNetValue / (+SALES.newSales.totalNetValue + +SALES.newSales.totalVatValue))).toFixed(2);
    }
    let clonedProducts = structuredClone(SALES.newSales.products);
    for (let prod of clonedProducts) {
      if (prod?.isTaxLine !== "true") {
        const ratio = (+prod.unitPrice * +prod.quantity) / (+SALES.newSales.totalNetValue + +SALES.newSales.totalDiscount);
        const discountAmount = +Number(ratio * toApplyAmount).toFixed(2);
        prod.isPerDiscount = "false";
        prod.isDiscountAmount = "true";
        prod.discount = discountAmount;
        prod.netValue = getNetValue(prod.unitPrice, prod.quantity, prod.discount);
        prod.taxes = getTaxes(prod, SETTINGS);
        prod.otherTaxEuro = getProductOtherTax(prod, SETTINGS);
        prod.witholdTaxEuro = getProductWithholdTax(prod, SETTINGS);
        prod.feeEuro = getProductFee(prod, SETTINGS);
        prod.stampEuro = getProductStamp(prod, SETTINGS);
        prod.vat = getVatValue(prod.netValue, prod.vatPercentage);
        prod.totalValue = getTotalValue(prod.netValue, prod.vatPercentage, prod.taxes);
      }
    }

    let productTotals = getSalesTotals(clonedProducts, SETTINGS);
    let productSalesTaxes = getSalesTaxesData(clonedProducts, SALES.newSales.extraData, productTotals, SETTINGS);
    let totalTaxes = 0;
    let withHoldTaxes = 0;
    let deductions = 0;
    if(productSalesTaxes.length > 0 && productSalesTaxes[0].vatPercentage === "Invoice Level Tax"){
      totalTaxes = parseFloat( (Number(productSalesTaxes[0].otherTaxes) + Number(productSalesTaxes[0].fees) + Number(productSalesTaxes[0].stamp)).toString());
      withHoldTaxes = parseFloat(productSalesTaxes[0].withholdTaxes).toFixed(2);
      deductions = parseFloat(productSalesTaxes[0].deductions).toFixed(2);
    }
    if(totalTaxes !== 0 || withHoldTaxes !== 0 || deductions !== 0){
      productTotals.paymentAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes) - parseFloat(withHoldTaxes) - parseFloat(deductions)).toFixed(2);
      productTotals.totalAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes)).toFixed(2);
    }
    let prepSaleObj = {
      ...SALES.newSales,
      products: clonedProducts,
      salesTaxes: productSalesTaxes,
      ...productTotals
    }
    prepSaleObj.discountAsLine = discountObj.discountAsLine;
    prepSaleObj.discountAsLineText = discountObj.discountAsLineText;

    dispatch(setNewSales(prepSaleObj));
    setShowDiscountModal(false);
    toast.success("Η έκπτωση εφαρμόστηκε επιτυχώς", {autoClose: 2000});
  }

  const handleOtherCorrelatedInvoicesTableUpdate = {
    insert: (e, data) => {
      if (e.row) {
        if (!ACTIVITY.saveSales) dispatch(setSaveSales(true));
        if (SALES.newSales?.otherCorrelatedInvoices?.some((el) => el.docMark === e.row.docMark)) {
          dispatch(setNewSales({...SALES.newSales, otherCorrelatedInvoices: SALES.newSales.otherCorrelatedInvoices}));
          return toast.error("Έχετε ήδη επιλέξει αυτό το παραστατικό.");
        }
        let clone = [];
        if (SALES.newSales?.otherCorrelatedInvoices?.length > 0) {
          clone = structuredClone(SALES.newSales?.otherCorrelatedInvoices);
        }
        let cloneRow = {...e.row};
        delete cloneRow.date;
        clone.push(cloneRow);
        dispatch(setNewSales({...SALES.newSales, otherCorrelatedInvoices: clone}));
      }
    },
    update: (data, id, rowIndex, e) => {
      if (!ACTIVITY.saveSales) dispatch(setSaveSales(true));
      const findSame = SALES.newSales?.otherCorrelatedInvoices?.findIndex((el) => el.docMark === e.row.docMark);
      if (e.row?.docMark && findSame !== rowIndex) {
        dispatch(setNewSales({...SALES.newSales, otherCorrelatedInvoices: SALES.newSales.otherCorrelatedInvoices}));
        setTimeout(() => setIncrKey3(incrKey3 + 1), 50);
        return toast.error("Έχετε ήδη επιλέξει αυτό το παραστατικό.");
      }
      let clone = structuredClone(SALES.newSales?.otherCorrelatedInvoices);
      let cloneRow = {...e.row}
      delete cloneRow.date;
      clone[rowIndex] = {...clone[rowIndex], ...cloneRow}
      dispatch(setNewSales({...SALES.newSales, otherCorrelatedInvoices: clone}));
    },
    selected: () => {},
    delete: (id, rowIndex) => {
      if (rowIndex >= 0) {
        if (!ACTIVITY.saveSales) dispatch(setSaveSales(true));
        let clone = structuredClone(SALES.newSales?.otherCorrelatedInvoices);
        clone.splice(rowIndex, 1);
        dispatch(setNewSales({...SALES.newSales, otherCorrelatedInvoices: clone}));
      }
    }
  }

  const otherCorrelatedInvoicesTab = {
    tabName: "Συσχέτιση Παραστατικών/Προεισπράξεων POS",
    tabData: (
        <React.Fragment>
          <div className="text-muted mb-2"><i>Συσχέτιση διαβιβασμένων Παραστατικών/Προεισπράξεων POS</i></div>
          <EditableTable
              name={"New Sale Other Correlated Invoices"}
              columns={otherCorrelatedInvoicesTableColumns}
              key={incrKey3}
              data={SALES.newSales?.otherCorrelatedInvoices ? SALES.newSales?.otherCorrelatedInvoices : []}
              allowActions={true}
              allowInsertRow={true}
              onUpdate={handleOtherCorrelatedInvoicesTableUpdate}
          />
          {SALES.newSales.otherCorrelatedInvoices?.some((el) => el.docMyDataType === "8.4") && (
              <span className={"text-muted"}>(*) Ο έλεγχος των ποσών των προεισπράξεων σε σχέση με το πληρωτέο ποσό, γίνεται κατά την διάρκεια της αποθήκευσης.</span>
          )}
        </React.Fragment>
    )
  }

  const hookNewClientInSale = (newClientData) => {
    if (newClientData) {
      const clientBasicData = {
        clientName: newClientData.name,
        client: newClientData._id,
        clientCode: newClientData.systemCode,
        clientType: 'Existing',
        address: newClientData.address,
        vat: String(newClientData.vatNumber).trim(),
        doy: getDOYOptions().find((el) => String(el.value) === String(newClientData.DOY))?.label,
        city: newClientData.city,
        amka: newClientData?.amka,
        clientCategoryName: newClientData.categoryName,
        clientCategory: newClientData.category,
        pc: newClientData.postalCode,
        country: newClientData.country,
        clientInstallationId: "0",
        clientInstallationType: "1",
        email: newClientData.email,
        phone: newClientData.phone,
        activity: newClientData.activity
      }
      newClientData.installations.map(installation => {
        installation.type = getLabelByValue(getInstallationsTypes(), installation.type, 'value');
        return installation;
      })
      clientBasicData.clientInstallationType = newClientData.installations[0]?.type;
      clientBasicData.clientInstallationId = newClientData.installations[0]?.no;

      const salesData = SALES.newSales;
      const newSalesData = {...salesData, ...clientBasicData}

      dispatch(setNewSales(newSalesData)); // Set auto select the newly added client
    }
  }

  const packingsDeclarationsTab = {
    tabName: "Δηλώσεις Συσκευασιών",
    tabData: (
        <React.Fragment>
          <PackingsDeclarations
              packingsDeclarations={SALES.newSales?.packingsDeclarations}
              callbackFunction={(packingsDeclarations) => dispatch(setNewSales({...SALES.newSales, packingsDeclarations}))}
              viewMode={false}
          />
        </React.Fragment>
    )
  }

  return (
      <div className="new-sales">
        {mainLoader && (
            <div className="overlay_main_loader">
              <Loader />
            </div>
        )}
        <div className="client-form product-form position-relative">
          {disabledFields && <div className="overlay_w">{t('SalesNew.message')}</div>}
          <Row className="border-bottom mb-2">
            <Col sm={12} md={4} className="showWithOverlay">
              <Dropdown
                  label={t('SalesNew.DocumentType')}
                  key={selectedDocumentType.value}
                  defaultValue={selectedDocumentType}
                  required={true}
                  searchEnable={true}
                  name="documentType"
                  options={documentTypesOptions}
                  onChange={(e) => handleOnChange(e, 'dd', 'documentType')}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="12" md="3">
              {/* If "MyData rules" is enabled in "Settings-Document Types-Advanced Types", then FIELD IS READ ONLY. Select current date only. */}
              <DateBox
                  classes="w-100 mb-2"
                  label={t('SalesNew.Date')}
                  name="date"
                  selected={new Date(SALES.newSales.date)}
                  readOnly={readOnlySalesDate}
                  allowOlderDate={allowOlderDate}
                  allowOlderDateValue={checkPermission("custom-logistirio", permissionsData) === false ? pMDDSettings.otherData.filter(otherData => otherData.name === "allowOlderDate")[0].value : "999999"}
                  onChange={(e) => handleOnChange(e, 'dp', 'date')}
              />
            </Col>
            <Col sm="12" md="1">
              <HourPicker
                  label={t('SalesNew.time')}
                  disabled={readOnlySalesTime && !allowOlderDate}
                  selected={moment(SALES.newSales.time, "HH:mm").toDate()}
                  onChange={(e) => handleOnChange(e, "tp", "time")}
              />
            </Col>
          </Row>
          <Row className={"mb-2"}>
            <Col sm="12" md="4">
              <Dropdown
                  className={"mb-0"}
                  label={t('SalesNew.installation')}
                  options={dtInstallationsOptions}
                  value={Object.keys(selectDocumentInstallation).length !== 0 ? selectDocumentInstallation : ''}
                  enabledValue={true}
                  searchEnable={true}
                  required={true}
                  name="installation"
                  onChange={(e) => handleOnChange(e, 'dd', 'installation')}
                  disabled={String(SALES.newSales?.corelatedDocument).length === 24}
              />
            </Col>
            <Col sm="12" md="4">
              <Dropdown
                  className={"mb-0"}
                  label={t('SalesNew.preNumber.preNumber')}
                  name="preNumber"
                  required={true}
                  key={Math.random()}
                  defaultValue={Object.keys(selectPreNumber).length !== 0 ? selectPreNumber : ''}
                  options={preNumberGreekOptions}
                  disabled={SALES.newSales.numberingMode === 'manual'}
                  onChange={(e) => handleOnChange(e, 'dd', 'preNumber')}
              />
              {ACTIVITY.saveSales  && SALES.newSales.preNumber === "" && <div className="text-danger">{t('SalesNew.preNumber.required')}</div>}
            </Col>
            <Col sm="12" md="4">
              <Input
                  label={t('SalesNew.number.number')}
                  name="number"
                  required={true}
                  value={SALES.newSales.number}
                  placeholder={t('SalesNew.number.placeholder')}
                  onChange={(e) => handleOnChange(e)}
                  disabled={SALES.newSales.numberingMode !== 'manual' && !allowOlderDate}
                  autoComplete={"off"}
              />
              {ACTIVITY.saveSales  && SALES.newSales.number === "" && <div className="text-danger">{t('SalesNew.number.required')}</div>}
            </Col>
          </Row>
          {showCorelatedDocument &&
              <Row>
                <Col sm="12" md="4" className={"mb-2"}>
                    <AdvancedCombobox
                        ACName="Sales Corelated Document" // do not change name
                        className="w-100 ac-select-dropdown corelated-doc"
                        popupClassName="corelated-doc-popup"
                        defaultValue={SALES.newSales?.corelatedDocumentName}
                        key={SALES.newSales?.corelatedDocument}
                        label={t('SalesNew.corelatedDocument.corelatedDocument')}
                        data={corelatedDocumentsList}
                        onChange={(e) => handleOnChange(e, 'acdd', 'corelatedDocument') }
                        onChangeSearch={(keyword, setData) => {
                          if (String(keyword).length >= 1) {
                            fetchCorrelatedDocumentsList(keyword, setData);
                          }
                        }}
                        disabled={String(SALES.newSales?.corelatedDocument).length === 24}
                        excludeColumns={[]}
                        columns={corelatedDocumentColumns}
                        deleteEnable={false}
                        searchTableEnable={false}
                        showTableOptionOnSelect={true}
                        placeholder={t('SalesNew.corelatedDocument.placeholder')}
                        showInsertAddButton={true}
                        hideSaveButton={true}
                        hideInsertNewRow={true}
                        required={isCorelatedDocumentMandatory}
                        inputFieldClasses="form-control"
                    />
                    {
                        ACTIVITY.saveSales &&
                        isCorelatedDocumentMandatory &&
                        (SALES.newSales.client !== '' || SALES.newSales.newClient !== '') &&
                        SALES.newSales.corelatedDocument === "" &&
                        <div className="text-danger">{t('SalesNew.corelatedDocument.required')}</div>
                    }
                </Col>
                <Col sm="12" md="1">
                  {String(SALES.newSales?.corelatedDocument).length === 24 &&
                      <button style={{position: "absolute", bottom: "16px"}} className="btn btn-sm"
                              title="Καθαρισμός συσχετιζόμενου παραστατικού" onClick={() => dispatch(setNewSales({...SALES.newSales, corelatedDocument: "", corelatedDocumentName: ""}))}>
                        <i className="fas fa-xmark"></i></button>
                  }
                </Col>
              </Row>
          }
          <Row>
            {SALES.newSales.clientType === 'Existing' &&
              <Col md="5" className={"mb-2"}>
                <AdvancedCombobox
                    ACName="Sales Client" // do not change name
                    className="w-200 ac-select-dropdown"
                    key={SALES.newSales.clientName}
                    defaultValue={SALES.newSales.clientName}
                    label={t('SalesNew.client.client')}
                    data={clientsListData}
                    onChangeSearch={onChangeSearch}
                    onChange={(e) => handleOnChange(e, 'acdd', 'client')}
                    excludeColumns={[]}
                    columns={clientDropdownColumns}
                    deleteEnable={false}
                    searchTableEnable={false}
                    showTableOptionOnSelect={true}
                    placeholder={t('SalesNew.client.placeholder')}
                    required={true}
                    showInsertAddButton={true}
                    hideSaveButton={true}
                    hideInsertNewRow={true}
                    inputFieldClasses="form-control"
                    disabled={String(SALES.newSales?.corelatedDocument).length === 24}
                />
                {ACTIVITY.saveSales && SALES.newSales.clientType === 'New' && SALES.newSales.newClient === "" && <div className="text-danger">{t('SalesNew.client.required')}</div>}
                {ACTIVITY.saveSales && SALES.newSales.clientType === 'Existing' && SALES.newSales.client === "" && <div className="text-danger">{t('SalesNew.client.required')}</div>}
              </Col>
            }
            {SALES.newSales.clientType === 'New' &&
              <Col md="5" className={"mb-2"}>
                <Input
                    className="w-100 newclient-field"
                    label={t('SalesNew.newRetailClient.newRetailClient')}
                    name="newClient"
                    autoComplete={"off"}
                    value={SALES.newSales.newClient}
                    placeholder={t('SalesNew.newRetailClient.placeholder')}
                    onChange={(e) => handleOnChange(e)}
                />
              </Col>
            }
            {String(SALES.newSales?.corelatedDocument).length === 24 ? (
                <Col md={1}></Col>
            ) : (
                <Col sm="1" md="1">
                  <div className="d-flex  mt-4">
                    <div className="quick-client-actions">
                      {SALES.newSales.client !== '' && SALES.newSales.clientType === 'Existing' && <QuickEdit title="Edit selected client." columns={quickClientFields} data={quickEditClientData} hideCurrentValue={true} updateData={quickEditClient} />}
                      {SALES.newSales.client !== '' && SALES.newSales.clientType === 'Existing' && <button className="btn quick-retail-clientbtn btn-default btn-sm" title="Clear Client Fields" onClick={clearClient}><i className="fas fa-xmark"></i></button>}
                      {((SALES.newSales.client === '' && SALES.newSales.newClient === '') || SALES.newSales.clientType !== 'Existing') && <NewClientModal myDataType={SALES.newSales.myDataType} successCallback={(data) => hookNewClientInSale(data)} />}
                    </div>
                  </div>
                </Col>
            )}
            {(SALES.newSales.clientType === 'Existing' && isEmpty(SALES.newSales.amka)) && (
                <Col sm="12" md="2">
                  <div className="d-flex">
                    <AdvancedCombobox
                        ACName="Client Installation" // do not change name
                        className="w-100 ac-select-dropdown"
                        defaultValue={SALES.newSales.clientInstallationType}
                        label={t('SalesNew.clientInstallation.clientInstallation')}
                        data={clientInstallationListData}
                        onChangeSearch = {onChangeSearch}
                        onChange={(e) => handleOnChange(e, 'acdd', 'clientInstallation')}
                        excludeColumns={[]}
                        columns={clientInstallationsDropdownColumns}
                        deleteEnable={false}
                        searchTableEnable={false}
                        showTableOptionOnSelect={true}
                        placeholder={t('SalesNew.clientInstallation.placeholder')}
                        required={true}
                        showInsertAddButton={true}
                        hideSaveButton={true}
                        hideInsertNewRow={true}
                        inputFieldClasses="form-control"
                        disabled={String(SALES.newSales?.corelatedDocument).length === 24}
                    />
                  </div>
                </Col>
            )}
            {(SALES.newSales.clientType === 'Existing' && !isEmpty(SALES.newSales.amka)) && (
                <Col sm="12" md="2" className={"mb-2"}>
                  <Input
                      className="w-100"
                      label={"ΑΜΚΑ Ασθενή"}
                      name="amka"
                      autoComplete={"off"}
                      value={SALES.newSales.amka}
                      onChange={(e) => handleOnChange(e)}
                      disabled={true}
                      readonly
                  />
                </Col>
            )}
            {SALES.newSales.clientType === 'Existing' && (
              <Col sm="12" md="2" className={"mb-2"}>
                <Input
                    className="w-100"
                    label={t('SalesNew.vat')}
                    name="vat"
                    autoComplete={"off"}
                    value={SALES.newSales.vat}
                    onChange={(e) => handleOnChange(e)}
                    disabled={true}
                    readonly
                />
              </Col>
            )}
            {SALES.newSales.clientType === 'Existing' && (
                <Col sm="12" md="2" className={"mb-2"}>
                  <Input
                      className="w-100"
                      label={t('SalesNew.doy')}
                      name="doy"
                      autoComplete={"off"}
                      value={SALES.newSales.doy}
                      onChange={(e) => handleOnChange(e)}
                      disabled={true}
                      readonly
                  />
                </Col>
            )}
            {/* Show if new client */}
            {SALES.newSales.clientType === 'New' &&
                <Col sm="12" md="2" className={"mb-2"}>
                  <Input
                      className="w-100"
                      label={t('SalesNew.email.email')}
                      name="email"
                      autoComplete={"off"}
                      required={SALES.newSales.clientType === 'New' && SALES.newSales.phone === ''}
                      value={SALES.newSales.email}
                      onChange={(e) => handleOnChange(e)}
                  />
                  {ACTIVITY.saveSales && SALES.newSales.clientType === 'New' && SALES.newSales.email === "" && SALES.newSales.phone === "" && <div className="text-danger">{t('SalesNew.email.required')}</div>}
                </Col>
            }
            {/* Show if new client */}
            {SALES.newSales.clientType === 'New' &&
                <Col sm="12" md="2" className={"mb-2"}>
                  <Input
                      className="w-100"
                      label={t('SalesNew.phone.phone')}
                      name="phone"
                      autoComplete={"off"}
                      required={SALES.newSales.clientType === 'New' && SALES.newSales.email === ''}
                      value={SALES.newSales.phone}
                      onChange={(e) => handleOnChange(e)}
                    />
                </Col>
            }
          </Row>
          <Row>
            <Col sm="12" md="2" className={"mb-2"}>
              <Input
                  className="w-100"
                  label={t('SalesNew.city')}
                  name="city"
                  autoComplete={"off"}
                  value={SALES.newSales.city}
                  required={isDelivery}
                  onChange={(e) => handleOnChange(e)}
              />
            </Col>
            <Col sm="12" md="2" className={"mb-2"}>
              <Input
                  className="w-100"
                  label={t('SalesNew.address')}
                  name="address"
                  autoComplete={"off"}
                  value={SALES.newSales.address}
                  required={isDelivery}
                  disabled={String(SALES.newSales?.corelatedDocument).length === 24}
                  onChange={(e) => handleOnChange(e)}
              />
            </Col>
            <Col sm="12" md="2" className={"mb-2"}>
              <Input
                  className="w-100"
                  label={t("General.postalCode")}
                  name="pc"
                  autoComplete={"off"}
                  value={SALES.newSales.pc}
                  required={isDelivery}
                  onChange={(e) => handleOnChange(e)}
              />
            </Col>
            <Col md={6} className={"mb-2"}>
              <Input
                  className="w-100"
                  label={t('General.activity')}
                  name="activity"
                  autoComplete={"off"}
                  value={SALES.newSales.activity}
                  onChange={(e) => handleOnChange(e)}
                  disabled={SALES.newSales.clientType !== 'New'}
                  readonly
              />
            </Col>
          </Row>
          {(checkPermission("sales-dcl/new-write", permissionsData) && selectedDocumentTypeData['mydataProvider'] === "active" && !["11.4", "5.1", "5.2"].includes(selectedDocumentTypeData["myDataType"])) &&
              <Row hidden={isEmpty(SALES.newSales?.client)}>
                <Col sm="12" md="6" className={"mb-2"}>
                  <AdvancedCombobox
                      ACName="Sales Corelated Dcl" // do not change name
                      className="w-100 ac-select-dropdown corelated-doc"
                      popupClassName="corelated-doc-popup"
                      defaultValue={SALES.newSales?.correlatedDclName}
                      key={SALES.newSales?.correlatedDclObj}
                      label={"Συσχετιζόμενη Εγγραφή Ψηφιακού Πελατολογίου"}
                      data={correlatedDclList}
                      onChange={(e) => handleOnChange(e, 'acdd', 'correlatedDcl') }
                      onChangeSearch={(keyword, setData) => {
                        if (String(keyword).length >= 1) {
                          fetchCorrelatedDclList(keyword, setData);
                        }
                      }}
                      disabled={String(SALES.newSales?.correlatedDclObj).length === 24}
                      excludeColumns={[]}
                      columns={dclListDropdownColumns}
                      deleteEnable={false}
                      searchTableEnable={false}
                      showTableOptionOnSelect={true}
                      placeholder={"Επιλέξτε Συσχετιζόμενη Εγγραφή"}
                      showInsertAddButton={true}
                      hideSaveButton={true}
                      hideInsertNewRow={true}
                      inputFieldClasses="form-control"
                  />
                </Col>
                <Col sm="12" md="1">
                  {String(SALES.newSales?.correlatedDclObj).length === 24 &&
                      <button style={{position: "absolute", bottom: "10px"}} className="btn btn-sm"
                              title="Καθαρισμός συσχετιζόμενης Εγγραφής" onClick={() => {
                        dispatch(setNewSales({...SALES.newSales, correlatedDclObj: "", correlatedDclName: ""}));
                        dispatch(setShowDclAfterSaleNew(false));
                        dispatch(setShowDclPageAfterSaleNew(false));
                      }
                      }>
                        <i className="fas fa-xmark"></i></button>
                  }
                </Col>
              </Row>
          }
          <Row>
            <Col sm="12" md="4" className={"mb-2"}>
              <Dropdown
                  label={t('SalesNew.paymentType.paymentType')}
                  options={paymentTypeOptions}
                  value={Object.keys(selectPaymentTypeOptions).length !== 0 ? selectPaymentTypeOptions : ''}
                  enabledValue={true}
                  required={requiredPaymentType}
                  name="paymentType"
                  searchEnable={true}
                  className={"mb-0"}
                  disabled={lockPaymentType}
                  onChange={(e) => handleOnChange(e, 'dd', 'paymentType')}
              />
              {ACTIVITY.saveSales && requiredPaymentType && SALES.newSales.paymentTypeName === "" && <div className="text-danger">{t('SalesNew.paymentType.required')}</div>}
            </Col>
            {!hidePosBankField &&
                <Col sm="12" md="4" className={"mb-2"}>
                  <Dropdown
                      label={t('SalesNew.posBankAccount')}
                      options={bankOptions}
                      value={Object.keys(selectPosBankAccount).length !== 0 ? selectPosBankAccount : ''}
                      enabledValue={true}
                      required={!hidePosBankField}
                      name="bankAccount"
                      className={"mb-0"}
                      disabled={lockPaymentType}
                      onChange={(e) => handleOnChange(e, 'dd', 'bankAccount')}
                  />
                  {ACTIVITY.saveSales && !hidePosBankField && SALES.newSales.bankAccount === "" && <div className="text-danger">{t('SalesNew.posBankAccountRequired')}</div>}
                </Col>
            }
            <Col sm="12" md="4">
              <Dropdown
                  label={t('SalesNew.salePurpose')}
                  options={salesPurposeOptions}
                  key={Math.random()}
                  value={Object.keys(selectSalePurpose).length !== 0 ? selectSalePurpose : ''}
                  enabledValue={true}
                  searchEnable={true}
                  name="salePurpose"
                  onChange={(e) => handleOnChange(e, 'dd', 'salePurpose')}
              />
            </Col>
            {SALES.newSales.salePurpose === "19" && (
                <Col md={4} className={"mb-3"}>
                  <Input
                      name={"salePurposeName"}
                      label={"Περιγραφή σκοπού διακίνησης"}
                      required={true}
                      autoComplete={"off"}
                      value={SALES.newSales.salePurposeName ? SALES.newSales.salePurposeName : ""}
                      onChange={(e) => handleOnChange(e)}
                  />
                </Col>
            )}
          </Row>
          {(SALES.newSales?.myDataType === "1.1" || SALES.newSales?.myDataType === "2.1" || SALES.newSales?.myDataType === "5.1" || SALES.newSales?.myDataType === "5.2")
              && SETTINGS.settings.advancedTypesSales.find((doc) => doc._id === SALES.newSales.documentType)?.mydataProvider === "active"
              && SALES.newSales?.enablePeppol === "active"
              && (
              <Row className={"mb-2"}>
                <Col md={3}>
                  <BetterCheckBox
                      name={"enablePeppol"}
                      text={"Αφορά δημόσια σύμβαση"}
                      className={"mt-1 mb-1"}
                      checked={true}
                      disabled={true}
                  />
                </Col>
                {(SALES.newSales?.enablePeppol === "active") && (
                    <Col md={12}>
                      <div style={{borderRadius: "5px", border: "1px solid #ecf0f5", padding: "10px"}}>
                        <Row>
                          {SALES.newSales.myDataType !== "5.1" && (
                              <Col md={3}>
                                <Popover placement={"top"} content={
                                  <>
                                    Πεδίο ΔΡΟΜΟΛΟΓΗΣΗΣ. Το πεδίο χρησιμοποιείται ως Αναγνωριστικό<br/>
                                    Σύμβασης για τον τύπο του Προϋπολογισμού και λαμβάνει τις τιμές:<br/>
                                    «1|ΑΔΑ Ανάληψης» όταν αφορά τον Τακτικό Προϋπολογισμό (Φορέα Κεντρικής Διοίκησης)<br/>
                                    «2|Κωδικοποιημένος Ενάριθμος» όταν αφορά χρηματοδότηση μέσω ΠΔΕ<br/>
                                    «3|ΑΔΑ Ανάληψης» όταν αφορά λοιπούς προϋπολογισμούς (Φορέα Λοιπής Γενικής Κυβέρνησης)<br/>
                                    Ως ΑΔΑ Ανάληψης εννοείται ΑΔΑ Ανάληψης Υποχρέωσης. Οι κωδικοί ΑΔΑ<br/>
                                    και Ενάριθμος αναφέρονται στη Σύμβαση, ως πηγές χρηματοδότησης.
                                  </>
                                } title={<div style={{textAlign: "center"}}>Οδηγίες Α.Δ.Α. ή Ενάριθμου</div>}>
                                  <>
                                    <Input
                                        name={"projectReference"}
                                        label={"Α.Δ.Α. ή Ενάριθμος (BT-11)"}
                                        value={SALES.newSales?.peppol?.projectReference ? SALES.newSales.peppol.projectReference : ""}
                                        onChange={(e) => handleOnPeppolChange(e, "input", "projectReference")}
                                        required={true}
                                        disabled={String(SALES.newSales?.corelatedDocument).length === 24}
                                    />
                                  </>
                                </Popover>
                              </Col>
                          )}
                          <Col md={3}>
                            <Row>
                              <Col md={10}>
                                <Input
                                    name={"partyIdentification"}
                                    label={"Κωδικός Αναθέτουσας Αρχής (BT-46)"}
                                    value={SALES.newSales?.peppol?.partyIdentification ? SALES.newSales.peppol.partyIdentification : ""}
                                    placeholder={"Παρακαλώ επιλέξτε"}
                                    required={true}
                                    disabled={true}
                                />
                              </Col>
                              <Col md={2}>
                                <SelectAnathetousaModal
                                    data={SALES.newSales}
                                    selectFunction={(obj) => handleOnPeppolChange(null, "anathetousaModal", obj)}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col md={3}>
                            <Input
                                name={"contractDocumentReference"}
                                label={"Α.Δ.Α.Μ. (BT-12)"}
                                value={SALES.newSales?.peppol?.contractDocumentReference ? SALES.newSales.peppol.contractDocumentReference : ""}
                                onChange={(e) => handleOnPeppolChange(e, "input", "contractDocumentReference")}
                                disabled={String(SALES.newSales?.corelatedDocument).length === 24}
                            />
                          </Col>
                          <Col md={3}>
                            <DateBox
                                name={"dueDate"}
                                label={"Ημερομηνία"}
                                selected={moment(SALES.newSales?.peppol?.dueDate, "YYYY-MM-DD").isValid() ? moment(SALES.newSales?.peppol?.dueDate, "YYYY-MM-DD").toDate() : ""}
                                onChange={(e) => handleOnPeppolChange(e, "datebox", "dueDate")}
                                disabled={true}
                            />
                          </Col>
                        </Row>
                        <Row className={"mt-2"}>
                          <Col md={3}>
                            <Input
                                name={"paymentMethodInfo"}
                                label={"Όροι πληρωμής (BT-20)"}
                                placeholder={"Προσθέστε όρους πληρωμής"}
                                value={SALES.newSales?.peppol?.paymentMethodInfo ? SALES.newSales.peppol.paymentMethodInfo : ""}
                                onChange={(e) => handleOnPeppolChange(e, "input", "paymentMethodInfo")}
                            />
                          </Col>
                          <Col md={3}>
                            <Input
                                name={"buyerReference"}
                                label={"Στοιχείο Αναφοράς Αγοραστή (BT-10)"}
                                placeholder={"Προσθέστε στοιχείο αναφοράς αγοραστή"}
                                value={SALES.newSales?.peppol?.buyerReference ? SALES.newSales.peppol.buyerReference : ""}
                                onChange={(e) => handleOnPeppolChange(e, "input", "buyerReference")}
                            />
                          </Col>
                          <Col md={3}>
                            <Input
                                name={"purchaseOrderReference"}
                                label={"Αναφορά Εντολής Αγοράς (BT-13)"}
                                placeholder={"Προσθέστε αναφορά εντολή αγοράς"}
                                value={SALES.newSales?.peppol?.purchaseOrderReference ? SALES.newSales.peppol.purchaseOrderReference : ""}
                                onChange={(e) => handleOnPeppolChange(e, "input", "purchaseOrderReference")}
                            />
                          </Col>
                          <Col md={3}>
                            <Input
                                name={"salesOrderReference"}
                                label={"Στοιχείο αναφοράς εντολής πώλησης (BT-14)"}
                                placeholder={"Προσθέστε στοιχείο αναφοράς εντολής πώλησης"}
                                value={SALES.newSales?.peppol?.salesOrderReference ? SALES.newSales.peppol.salesOrderReference : ""}
                                onChange={(e) => handleOnPeppolChange(e, "input", "salesOrderReference")}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col md={3}>
                            <Button size={"sm"} onClick={() => handleCheckPeppolFields()} disabled={loadingCheckPeppolFields} className={"mt-3"}>Έλεγχος εγκυρότητας πεδίων {loadingCheckPeppolFields && <Spinner className={"ml-2"} animation="border" variant="dark" />}</Button>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                )}
              </Row>
              )}
          <Row>
            <Col md="12" className="mb-2">
              <ul className="react-tabs__tab-list tab-style tab-min component-subtabs">
                {(() => {
                  const tabs = [...newSalesTab];
                  if (isDeliveryNoteTypes.includes(SALES.newSales?.myDataType) || ["9.1", "9.2", "9.3"].includes(SALES.newSales?.myDataType)) {
                    tabs.push(newCorrelatedEntitiesTab);
                    tabs.push(packingsDeclarationsTab);
                  }
                  if (canHaveOtherCorrelations) tabs.push(otherCorrelatedInvoicesTab);

                  return tabs.map((tab, i) => (
                      <li key={i} className="react-tabs__tab">
                        <button type="button" onClick={() => setActiveTab(i)} className={`customNavBtn ${activeTab === i && "btnActive"}`}>
                          <span className="textWrapper">{tab.tabName}</span>
                        </button>
                      </li>
                  ));
                })()}
              </ul>
              {(() => {
                const tabs = [...newSalesTab];
                if (isDeliveryNoteTypes.includes(SALES.newSales?.myDataType) || ["9.1", "9.2", "9.3"].includes(SALES.newSales?.myDataType)) {
                  tabs.push(newCorrelatedEntitiesTab);
                  tabs.push(packingsDeclarationsTab);
                }
                if (canHaveOtherCorrelations) tabs.push(otherCorrelatedInvoicesTab);

                return <div className="innerTabPanel">{tabs[activeTab]?.tabData}</div>;
              })()}
            </Col>
          </Row>
          <Row>
            <Col sm="12" md="8" style={{position: "inherit"}}>
              <EditableTable
                  tableName={"Sales New Taxes Calculations"}
                  className="sales-taxes-calculations"
                  allowActions={false}
                  key={incrKey2}
                  data={fixDocumentTaxesDisplay(SALES.newSales, "sales")}
                  pRequestData={pRequestData}
                  columns={salesTaxesColumns}
                  actionButtons={{
                    print: false,
                    delete: false,
                    export: false,
                    edit: false,
                  }}
              />
            </Col>
            <Col sm="12" md="4" className="d-flex justify-content-end">
              <span className="mr-3 fw-bold">{t('SalesNew.totalsTable.title')}</span>
              <table className="table table-bordered mb-2">
                <tbody>
                <tr><td className="fw-bold">{t('SalesNew.totalsTable.totalQuantity')}</td><td>{totalQuantity}</td></tr>
                <tr><td className="fw-bold">{t('SalesNew.totalsTable.totalBeforeDiscount')}</td><td>{getGreekCurrencyFormat(totalBeforeDiscount)}</td></tr>
                <tr><td className="fw-bold">{t('SalesNew.totalsTable.totalDiscount')}</td><td>{getGreekCurrencyFormat(totalDiscount)}</td></tr>
                <tr><td className="fw-bold">{t('SalesNew.totalsTable.totalNetValue')}</td><td>{getGreekCurrencyFormat(totalNetValue)}</td></tr>
                <tr><td className="fw-bold">{t('SalesNew.totalsTable.totalVatAmount')}</td><td>{getGreekCurrencyFormat(totalVatAmount)}</td></tr>
                <tr><td className="fw-bold">{t('SalesNew.totalsTable.totalWithHoldTaxesAmount')}</td><td>{getGreekCurrencyFormat(withHoldTaxes)}</td></tr>
                <tr><td className="fw-bold">{t('SalesNew.totalsTable.totalTaxesAmount')}</td><td>{getGreekCurrencyFormat(totalTaxes)}</td></tr>
                <tr><td className="fw-bold">{t('SalesNew.totalsTable.totalAmount')}</td><td>{getGreekCurrencyFormat(totalAmount)}</td></tr>
                {isProviderPosPayment && (
                    <tr>
                      <td className="fw-bold">Φιλοδώρημα</td>
                      <td>
                        <TipComponent
                            paymentAmount={paymentAmount}
                            value={SALES.newSales.tipAmount}
                            onChange={(amount) => dispatch(setNewSales({...SALES.newSales, tipAmount: amount}))}
                        />
                      </td>
                    </tr>
                )}
                <tr>
                  <td className="fw-bold">{t('SalesNew.totalsTable.paymentAmount')}</td>
                  {(SALES.newSales.tipAmount ? (
                      <td>{getGreekCurrencyFormat((Number(SALES.newSales.paymentAmount) + Number(SALES.newSales.tipAmount)).toFixed(2))}</td>
                  ) : (
                      <td>{getGreekCurrencyFormat(SALES.newSales.paymentAmount)}</td>
                  ))}
                </tr>
                </tbody>
              </table>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div style={{width: "100%"}}>
                <div className="text-muted mb-2"><i>{t('SalesNew.salesNotes')}</i></div>
                <TextArea
                    rows="4"
                    placeholder={t('SalesNew.addNotes')}
                    name="notes"
                    value={SALES.newSales.notes}
                    onChange={(e) => handleOnChange(e)}
                />
              </div>
            </Col>
          </Row>
          {[...isDeliveryNoteTypes, "9.1", "9.2", "9.3"].includes(SALES.newSales?.myDataType) && (
              <Row className={"mt-3"}>
                <div className="text-muted mb-2"><i>Επιλογές Διακίνησης</i></div>
                <Col md={4}>
                  <BetterCheckBox
                      name={"nonObligatedRecipient"}
                      text={"Μη Υπόχρεος Λήπτης"}
                      checked={SALES.newSales.nonObligatedRecipient}
                      onChange={(e) => handleOnChange(e, "checkbox", "nonObligatedRecipient")}
                  />
                </Col>
                <Col md={4}>
                  <BetterCheckBox
                      name={"withoutDigitalTransportTracking"}
                      text={"Χωρίς ψηφιακή παρακολούθηση διακίνησης"}
                      checked={SALES.newSales.withoutDigitalTransportTracking}
                      onChange={(e) => handleOnChange(e, "checkbox", "withoutDigitalTransportTracking")}
                  />
                </Col>
              </Row>
          )}
        </div>
        {/* Confirm Category Change */}
        <Modal backdrop={"static"} className="themeModal" show={showCategoryConfirmation} onHide={() => setshowCategoryConfirmation(false)}>
          <Modal.Header closeButton>
            <Modal.Title>{t('SalesNew.warning')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{t('SalesNew.warningMessage')}</Modal.Body>
          <Modal.Footer>
            <Button variant="outline-primary" onClick={() => setshowCategoryConfirmation(false)}>{t('SalesNew.no')}</Button>
            <Button variant="primary" onClick={() => handleConfirmCategory()} >{t('SalesNew.yes')}</Button>
          </Modal.Footer>
        </Modal>

        <Modal backdrop={"static"} show={showDiscountModal} onHide={() => setShowDiscountModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Εφαρμογή Έκπτωσης</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={12}>
                <Dropdown
                    name={"discountType"}
                    label={"Τύπος Έκπτωσης"}
                    options={discountTypeOptions}
                    key={Math.random()}
                    defaultValue={discountTypeOptions.find((el) => el.value === discountObj.discountType)}
                    onChange={(e) => handleOnDiscountChange(e, "dropdown", "discountType")}
                />
              </Col>
              <Col md={12}>
                <Input
                    name={"amount"}
                    label={discountObj.discountType === "percentage" ? "Ποσοστό %" : "Ποσό €"}
                    value={discountObj.amount}
                    type={"number"}
                    autoComplete={"off"}
                    onChange={(e) => handleOnDiscountChange(e, "input", "amount")}
                />
              </Col>
              <Col md={12}>
                <BetterCheckBox
                    name={"discountAsLine"}
                    text={"Προβολή έκπτωσης ως γραμμή παραστατικού"}
                    checked={discountObj.discountAsLine}
                    className={"mt-3"}
                    onChange={(e) => handleOnDiscountChange(e, "cb", "discountAsLine")}
                />
              </Col>
              {discountObj.discountAsLine === true && (
                  <Col md={12}>
                    <Input
                        name={"discountAsLineText"}
                        label={"Περιγραφή έκπτωσης"}
                        required={true}
                        value={discountObj.discountAsLineText}
                        onChange={(e) => handleOnDiscountChange(e, "input", "discountAsLineText")}
                    />
                  </Col>
              )}
              <Col md={12} className={"mt-3"}>
                <Alert variant={"secondary"}>Κατά την αποθήκευση οι προϋπάρχουσες εκπτώσεις θα αντικατασταθούν με τις καινούργιες.</Alert>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-primary" onClick={() => setShowDiscountModal(false)}>Κλείσιμο</Button>
            <Button variant="primary" onClick={() => handleSaveDiscount()}>Εφαρμογή Έκπτωσης</Button>
          </Modal.Footer>
        </Modal>
        <OtherCorrelatedEntitiesModal
            entity={selectedEntity}
            setSelectedEntity={setSelectedEntity}
            otherCorrelatedEntities={SALES.newSales.otherCorrelatedEntities || []}
            setOtherCorrelatedEntities={(arr) => dispatch(setNewSales({...SALES.newSales, otherCorrelatedEntities: arr}))}
        />
      </div>
  )
}

export default SalesNew;
